<template>
  <div class="dettaglio-offerta">
    <div class="header-tab">
      <div class="my-label col-24 no-padding">
        {{ $t('dettaglioOfferta.offerta').toUpperCase() + ' ' + offerta.numRif }}
      </div>
      <div class="row row-custom">
        <div class="sotto-label offset-lg-3 col-lg-18 offset-4 col-15 no-padding">
          {{ '(' + $t('dettaglioOfferta.del') + ' ' }}{{ offerta.datOfferta | formatDate }}{{ ')' }}
        </div>
        <div class="col-lg-2 col-sm-1 col-3 icona-doc" style="text-align: right">
          <el-tooltip class="item" effect="dark" :content="($t('dettaglioOfferta.documentiOfferta'))" placement="top">
            <div class="tooltip-div">
              <icon name="riv-archivio" scale="1.2" @click.native="goToDocumentiOfferta" class="pointer"></icon>
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>

    <div class="testata row row-custom">
      <div class="col-lg-11 col-sm-20 col-22">
        <div class="row row-custom elemento">
          <div class="testata-label col-8">
            {{ $t('dettaglioOfferta.rifCof') }}
          </div>
          <div class="testata-value col-16 no-padding">
            <el-input v-model="testata.rifCof" :disabled="disabled" :maxlength="12" class="custom-input"></el-input>
          </div>
        </div>
        <div class="row row-custom elemento">
          <div class="testata-label col-8">
            {{ $t('dettaglioOfferta.del') }}
          </div>
          <div class="testata-value col-16 no-padding">
            <el-date-picker
              v-model="testata.datRifCof" :disabled="disabled"
              type="date" format="dd/MM/yyyy" value-format="ddMMyyyy"
              placeholder="" class="custom-date-picker"
              :picker-options="{
                                firstDayOfWeek: 1
                              }">
            </el-date-picker>
          </div>
        </div>
        <div class="row row-custom elemento">
          <div class="testata-label col-8">
            {{ $t('dettaglioOfferta.validaFino') }}
          </div>
          <div class="testata-value col-16 no-padding">
            <el-date-picker :disabled="disabled"
                            v-model="testata.datValidita"
                            type="date" format="dd/MM/yyyy" value-format="ddMMyyyy"
                            placeholder="" class="custom-date-picker"
                            :picker-options="{
                              firstDayOfWeek: 1
                            }">
            </el-date-picker>
          </div>
        </div>
        <div class="row row-custom elemento">
          <div class="testata-label col-8">
            {{ $t('dettaglioOfferta.note') }}
          </div>
          <div class="col-16 textarea no-padding">
            <el-input v-model="testata.notaTes" type="textarea" resize="none" class="custom-input"
                      :disabled="disabled" :maxlength="200"></el-input>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-sm-20 col-22">
        <div class="row row-custom elemento">
          <div class="testata-label col-8">
            <span v-if="(!testata.codResaT || testata.codResa === testata.codResaT)">{{ $t('dettaglioOfferta.resa') }}</span>
            <el-tooltip class="item" effect="dark" :content="($t('dettaglioOfferta.valPrecedente') + ': ' + testata.codResa + ' - ' + testata.desResa)" placement="top" v-else>
              <span>{{ $t('dettaglioOfferta.resa') }}</span>
            </el-tooltip>
          </div>
          <div class="testata-value col-16 no-padding">
            <el-select v-model="testata.codResaT_2" :disabled="disabled" class="custom-select-el" v-if="(!testata.codResaT || testata.codResa === testata.codResaT)">
              <el-option
                v-for="item in rese"
                :key="item.codResa"
                :label="item.codResa + ' - ' + item.desResa"
                :value="item.codResa">
              </el-option>
            </el-select>
            <el-select v-model="testata.codResaT_2" :disabled="disabled" class="custom-select-el select-el-modificato" v-else>
              <el-option
                v-for="item in rese"
                :key="item.codResa"
                :label="item.codResa + ' - ' + item.desResa"
                :value="item.codResa">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="row row-custom elemento">
          <div class="testata-label col-8">
            {{ $t('dettaglioOfferta.divisa') }}
          </div>
          <div class="testata-value col-16 no-padding">
            <el-select v-model="testata.divisa" :disabled="disabled" @change="changeDivisa" class="custom-select-el">
              <el-option
                v-for="item in divise"
                :key="item.codDivisa"
                :label="item.desDivisa"
                :value="item.codDivisa">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="row row-custom elemento">
          <div class="testata-label col-8">
            <span v-if="(!testata.costTraspT || testata.costTrasp === testata.costTraspT)">{{ $t('dettaglioOfferta.trasporto') }}</span>
            <el-tooltip class="item" effect="dark" :content="($t('dettaglioOfferta.valPrecedente') + ': ' + testata.costTrasp)" placement="top" v-else>
              <span>{{ $t('dettaglioOfferta.trasporto') }}</span>
            </el-tooltip>
          </div>
          <div class="testata-value col-5 no-padding">
            <el-input v-model="testata.costTraspT_2" :disabled="disabled || testata.ifEditTraspImbal === '0'" class="custom-input" v-if="(!testata.costTraspT || testata.costTrasp === testata.costTraspT)"></el-input>
            <el-input v-model="testata.costTraspT_2" :disabled="disabled || testata.ifEditTraspImbal === '0'" class="custom-input input-el-modificato" v-else></el-input>
          </div>

          <div class="testata-label col-6">
            <span v-if="(!testata.costImbalT || testata.costImbal === testata.costImbalT)">{{ $t('dettaglioOfferta.imballo') }}</span>
            <el-tooltip class="item" effect="dark" :content="($t('dettaglioOfferta.valPrecedente') + ': ' + testata.costImbal)" placement="top" v-else>
              <span>{{ $t('dettaglioOfferta.imballo') }}</span>
            </el-tooltip>
          </div>
          <div class="testata-value col-5 no-padding">
            <el-input v-model="testata.costImbalT_2" :disabled="disabled || testata.ifEditTraspImbal === '0'" class="custom-input" v-if="(!testata.costImbalT || testata.costImbal === testata.costImbalT)"></el-input>
            <el-input v-model="testata.costImbalT_2" :disabled="disabled || testata.ifEditTraspImbal === '0'" class="custom-input input-el-modificato" v-else></el-input>
          </div>
        </div>
        <div class="row row-custom elemento">
          <div class="testata-label col-8">
            <span v-if="(!testata.codPagT || testata.codPag === testata.codPagT)">{{ $t('dettaglioOfferta.pagamento') }}</span>
            <el-tooltip class="item" effect="dark" :content="($t('dettaglioOfferta.valPrecedente') + ': ' + testata.codPag + ' - ' + testata.desPag)" placement="top" v-else>
              <span>{{ $t('dettaglioOfferta.pagamento') }}</span>
            </el-tooltip>
          </div>
          <div class="testata-value col-16 no-padding">
            <div class="pagamento" v-if="(!testata.codPagT || testata.codPag === testata.codPagT)">
              {{ (testata.codPagT_2 !== undefined) ? (testata.codPagT_2 + ' - ' + testata.desPagT_2) : '-' }}
            </div>
            <div class="modificato" v-else>
              {{ testata.codPagT_2 + ' - ' + testata.desPagT_2 }}
            </div>
          </div>
        </div>
        <div class="row row-custom elemento">
          <div class="testata-label col-8">
            {{ $t('dettaglioOfferta.email') }}
          </div>
          <div class="testata-value col-16 no-padding">
            <el-input v-model="testata.indEmail" :disabled="disabled" class="custom-input"></el-input>
          </div>
        </div>

      </div>
    </div>

    <div class="separatore margin"></div>

    <div class="row row-custom dettaglio">
      <div class="tabella-prodotti col-xl-12 col-24">

        <el-table :data="prodotti"
          @row-click="selectProdotto" class="custom-table"
          :row-class-name="tableRowClass" :row-key="(row) => {row.codPos}"
        >
          <el-table-column
            width="40">

            <template slot-scope="scope">
              <div class="qta-wrapper"
                   v-if="(formProdotto[scope.row.codPos].edit === true && formProdotto[scope.row.codPos].saved !== true)">
                <icon name="riv-prenotazione" scale="1"></icon>
              </div>
              <div class="qta-wrapper" v-if="(formProdotto[scope.row.codPos].saved === true)">
                <icon name="riv-save" scale="1"></icon>
              </div>
            </template>

          </el-table-column>
          <el-table-column
            width="20"
            class-name="cell-no-padding-left">

            <template slot-scope="scope" v-if="(scope.row.statoSchedSic !== 'N')">
              <el-tooltip class="item" effect="dark" :content="$t('dettaglioOfferta.verde')" placement="top">
                <div class="cerchio verde" v-if="scope.row.statoSchedSic === '0'"></div>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="$t('dettaglioOfferta.rosso')" placement="top">
                <div class="cerchio rosso" v-if="scope.row.statoSchedSic === '1'"></div>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="$t('dettaglioOfferta.giallo')" placement="top">
                <div class="cerchio giallo" v-if="scope.row.statoSchedSic === '2' || scope.row.statoSchedSic === '3'"></div>
              </el-tooltip>
            </template>

          </el-table-column>
          <el-table-column
            label="#"
            prop="codPos"
            width="30"
            class-name="cell-no-padding">
          </el-table-column>
          <el-table-column
            prop="codProd"
            :label="$t('dettaglioOfferta.prodotto')"
            min-width="70">
          </el-table-column>
          <el-table-column
            :label="$t('dettaglioOfferta.qta')"
            min-width="60"
            class-name="cell-no-padding">

            <template slot-scope="scope">
              <div class="qta-wrapper">
                {{ scope.row.numQta + ' ' + scope.row.codUMis }}
              </div>
            </template>

          </el-table-column>
          <el-table-column
            prop="desProd"
            :label="$t('dettaglioOfferta.descrizione')"
            min-width="220">
          </el-table-column>
          <el-table-column
            prop="desProd"
            width="60"
            class-name="cell-no-padding icone">

            <template slot-scope="scope">
              <div class="icon-wrapper row row-custom actions">

                <div class="col-12 no-padding" v-if="false">
                  <icon name="riv-tick" scale="1"></icon>
                </div>
                <div class="col-12 no-padding" v-else></div>

                <div class="col-12 no-padding" v-if="(scope.row.fabDis.length > 0)" @click.stop.prevent="openDisegniModal(scope.row)">
                  <el-tooltip class="item" effect="dark" :content="($t('dettaglioOfferta.disegniARicambio'))" placement="top-start">
                    <icon name="riv-draw" scale="1.2" class="pointer"></icon>
                  </el-tooltip>
                </div>
                <div class="col-12 no-padding" v-else></div>

              </div>
            </template>

          </el-table-column>
        </el-table>

        <el-pagination v-if="(nrPages > 1)" :current-page.sync="currentPagePaginator"
                       background class="custom-pagination"
                       layout="prev, pager, next"
                       :total="nrItems"
                       :page-size="pag_for"
                       @current-change="changePage">
        </el-pagination>

      </div>
      <div class="dettaglio-prodotto col-xl-12 col-24">

        <el-carousel :autoplay="false" indicator-position="none" arrow="always" @change="changeSlide"
                     v-loading="loading" ref="carousel">
          <el-carousel-item v-for="item in prodotti" :key="item.codPos + ' ' + item.codProd">

            <div class="card">
              <div class="row row-custom">
                <div class="icone-prodotto-sx col-6 no-padding">
                  <icon name="riv-bellIncl" scale="1.2" v-if="(item.ifRiaperto === '1')" />
                  <!--
                  <el-tooltip class="item" effect="dark" :content="($t('dettaglioOfferta.valida'))" placement="top">
                    <icon name="riv-tick" scale="1.2" v-if="(item.ifRiaperto === '1' && !item.edit)" @click.native="convalida(item.codPos)" class="action pointer" />
                  </el-tooltip>
                  -->
                  <el-button v-if="(item.ifRiaperto === '1' && !item.edit)" class="custom-button" @click="convalida(item.codPos)">
                    {{ $t('dettaglioOfferta.valida') }}
                  </el-button>
                </div>
                <div class="titolo col-12">
                  {{ '#' + item.codPos + ' - ' + $t('dettaglioOfferta.prodotto').toUpperCase() + ' ' + item.codProd }}
                </div>
                <div class="icone-prodotto col-6 no-padding">
                  <el-tooltip class="item" effect="dark" :content="($t('dettaglioOfferta.trattativa'))" placement="top">
                    <div>
                      <icon name="riv-handshake" scale="1.5"
                            @click.native="goToTrattativa(item)" class="pointer"
                            v-if="(offerta.variante !== '0')">
                      </icon>
                      <!--
                      <icon name="riv-handshake" scale="1.5"
                            @click.native="goToTrattativa(item)" class="pointer"
                            v-if="((disabled && offerta.variante !== '0') || (item.ifRiaperto === '1'))">
                      </icon>
                      -->
                    </div>
                  </el-tooltip>

                  <el-tooltip class="item" effect="dark" :content="($t('dettaglioOfferta.lastOfferOrder'))" placement="top">
                    <div>
                      <icon name="riv-condEco" scale="1.2" @click.native="goToLastOffer(item)" class="pointer" v-if="!disabled"></icon>
                    </div>
                  </el-tooltip>

                  <el-tooltip class="item" effect="dark" :content="($t('dettaglioOfferta.documentiProdotto'))" placement="top">
                    <div>
                      <icon name="riv-archivio" scale="1.2" @click.native="goToDocumenti(item)" class="pointer"></icon>
                    </div>
                  </el-tooltip>
                </div>
              </div>
              <div class="des-estesa">
                <span v-if="(showDesEstesaFull === false)">{{ desProdEst | truncate }}</span>
                <span v-else>{{ desProdEst }}</span>
                <div class="col-24 no-padding" v-if="(desProdEst.length > 150)">
                  <span class="leggi-tutto pointer" @click="changeShowDesEstesaFull">
                    {{ (showDesEstesaFull === false) ? $t('dettaglioOfferta.leggiTutto') : $t('dettaglioOfferta.leggiMeno') }}
                  </span>
                </div>
              </div>

              <div class="form">
                <div class="row row-custom">
                  <div class="prodotto-label col-5 no-padding">
                    <span v-if="(!formProdotto[item.codPos].przUniT || formProdotto[item.codPos].przUni === formProdotto[item.codPos].przUniT)">{{ $t('dettaglioOfferta.prezzo') }}</span>
                    <el-tooltip class="item" effect="dark" :content="($t('dettaglioOfferta.valPrecedente') + ': ' + formProdotto[item.codPos].przUni)" placement="top" v-else>
                      <span>{{ $t('dettaglioOfferta.prezzo') }}</span>
                    </el-tooltip>
                  </div>
                  <div class="col-6 prz-uni">
                    <input v-model="formProdotto[item.codPos].przUniT_2" :disabled="disabled || (item.ifRiaperto === '0' && testata.variante !== '0')"
                              v-if="(!formProdotto[item.codPos].przUniT || formProdotto[item.codPos].przUni === formProdotto[item.codPos].przUniT)"
                              class="custom-input-standard"
                              v-on:keyup="changeRowPrz(item.codPos)" @focus="focusCheck(item.codPos)">
                    <input v-model="formProdotto[item.codPos].przUniT_2" :disabled="disabled"
                              v-else
                              class="custom-input-standard input-el-modificato"
                              v-on:keyup="changeRowPrz(item.codPos)" @focus="focusCheck(item.codPos)">
                  </div>
                  <div class="col-2 no-padding divisa">
                    {{ divisa }}
                  </div>

                  <div class="prodotto-label col-3 no-padding"
                    v-if="formProdotto[item.codPos].qtaTrattativaT && (!formProdotto[item.codPos].qtaTrattativa || formProdotto[item.codPos].qtaTrattativa === formProdotto[item.codPos].qtaTrattativaT)"
                  >
                    {{ $t('dettaglioOfferta.qta') }}
                  </div>
                  <div class="prodotto-label col-3 no-padding"
                    v-if="formProdotto[item.codPos].qtaTrattativaT && (formProdotto[item.codPos].qtaTrattativa && formProdotto[item.codPos].qtaTrattativa !== formProdotto[item.codPos].qtaTrattativaT)"
                  >
                    <el-tooltip class="item" effect="dark" :content="($t('dettaglioOfferta.valPrecedente') + ': ' + formProdotto[item.codPos].qtaTrattativa)" placement="top">
                      <span>{{ $t('dettaglioOfferta.qta') }}</span>
                    </el-tooltip>
                  </div>
                  <div class="col-6 prz-uni">
                    <input v-model="formProdotto[item.codPos].qtaTrattativaT_2" :disabled="disabled"
                              v-if="formProdotto[item.codPos].qtaTrattativaT && !formProdotto[item.codPos].qtaTrattativa"
                              class="custom-input-standard input-el-modificato"
                              @focus="focusCheck(item.codPos)" v-on:change="changeRow(item.codPos)">
                    <input v-model="formProdotto[item.codPos].qtaTrattativaT_2" :disabled="disabled || (item.ifRiaperto === '0' && testata.variante !== '0')"
                              v-if="formProdotto[item.codPos].qtaTrattativaT && (formProdotto[item.codPos].qtaTrattativa && formProdotto[item.codPos].qtaTrattativa === formProdotto[item.codPos].qtaTrattativaT)"
                              class="custom-input-standard"
                              @focus="focusCheck(item.codPos)" v-on:change="changeRow(item.codPos)">
                    <input v-model="formProdotto[item.codPos].qtaTrattativaT_2" :disabled="disabled"
                              v-if="formProdotto[item.codPos].qtaTrattativaT && (formProdotto[item.codPos].qtaTrattativa && formProdotto[item.codPos].qtaTrattativa !== formProdotto[item.codPos].qtaTrattativaT)"
                              class="custom-input-standard input-el-modificato"
                              @focus="focusCheck(item.codPos)" v-on:change="changeRow(item.codPos)">
                  </div>
                  <div class="col-2 no-padding divisa"
                    v-if="formProdotto[item.codPos].qtaTrattativaT && (!formProdotto[item.codPos].qtaTrattativa || formProdotto[item.codPos].qtaTrattativa === formProdotto[item.codPos].qtaTrattativaT)
                          || formProdotto[item.codPos].qtaTrattativaT && (formProdotto[item.codPos].qtaTrattativa && formProdotto[item.codPos].qtaTrattativa !== formProdotto[item.codPos].qtaTrattativaT)"
                  >
                    {{ formProdotto[item.codPos].codUMisForn }}
                  </div>
                </div>

                <div class="row row-custom">
                  <div class="prodotto-label col-5 no-padding">
                    <span v-if="(!formProdotto[item.codPos].scPerc1T || formProdotto[item.codPos].scPerc1 === formProdotto[item.codPos].scPerc1T)">{{ $t('dettaglioOfferta.scPerc1') + '(%)' }}</span>
                    <el-tooltip class="item" effect="dark" :content="($t('dettaglioOfferta.valPrecedente') + ': ' + formProdotto[item.codPos].scPerc1)" placement="top" v-else>
                      <span>{{ $t('dettaglioOfferta.scPerc1') + '(%)' }}</span>
                    </el-tooltip>
                  </div>
                  <div class="col-6">
                    <input v-model="formProdotto[item.codPos].scPerc1T_2" :disabled="disabled || (item.ifRiaperto === '0' && testata.variante !== '0')"
                              v-if="(!formProdotto[item.codPos].scPerc1T || formProdotto[item.codPos].scPerc1 === formProdotto[item.codPos].scPerc1T)"
                              @focus="focusCheck(item.codPos)" class="custom-input-standard"
                              v-on:change="changeRow(item.codPos)">
                    <input v-model="formProdotto[item.codPos].scPerc1T_2" :disabled="disabled"
                              v-else
                              @focus="focusCheck(item.codPos)" class="custom-input-standard input-el-modificato"
                              v-on:change="changeRow(item.codPos)">
                  </div>

                  <div class="prodotto-label col-5 no-padding">
                    <span v-if="(!formProdotto[item.codPos].scPerc2T || formProdotto[item.codPos].scPerc2 === formProdotto[item.codPos].scPerc2T)">{{ $t('dettaglioOfferta.scPerc2') + '(%)' }}</span>
                    <el-tooltip class="item" effect="dark" :content="($t('dettaglioOfferta.valPrecedente') + ': ' + formProdotto[item.codPos].scPerc2)" placement="top" v-else>
                      <span>{{ $t('dettaglioOfferta.scPerc2') + '(%)' }}</span>
                    </el-tooltip>
                  </div>
                  <div class="col-6">
                    <input v-model="formProdotto[item.codPos].scPerc2T_2" :disabled="disabled || (item.ifRiaperto === '0' && testata.variante !== '0')"
                              v-if="(!formProdotto[item.codPos].scPerc2T || formProdotto[item.codPos].scPerc2 === formProdotto[item.codPos].scPerc2T)"
                              @focus="focusCheck(item.codPos)" class="custom-input-standard"
                              v-on:change="changeRow(item.codPos)">
                    <input v-model="formProdotto[item.codPos].scPerc2T_2" :disabled="disabled"
                              v-else
                              @focus="focusCheck(item.codPos)" class="custom-input-standard input-el-modificato"
                              v-on:change="changeRow(item.codPos)">
                  </div>
                </div>

                <div class="row row-custom">
                  <div class="prodotto-label col-5 no-padding">
                    {{ $t('dettaglioOfferta.prodRif') }}
                  </div>
                  <div class="col-17">
                    <input v-model="formProdotto[item.codPos].codProdRif" :disabled="disabled || (item.ifRiaperto === '0' && testata.variante !== '0')"
                              @focus="focusCheck(item.codPos)" class="custom-input-standard"
                              v-on:change="changeRow(item.codPos)" :maxlength="35">
                  </div>
                </div>

                <div class="row row-custom">
                  <div class="prodotto-label col-5 no-padding">
                    {{ $t('dettaglioOfferta.consegna') }}
                  </div>
                  <div class="col-6">
                    <input v-model="formProdotto[item.codPos].numSettCons" :disabled="disabled || (item.ifRiaperto === '0' && testata.variante !== '0')"
                              @focus="focusCheck(item.codPos)" :maxlength="3" class="custom-input-standard"
                              v-on:change="changeRow(item.codPos, true)">
                  </div>
                  <div class="col-13 sett-cons no-padding">
                    {{ '(' + $t('dettaglioOfferta.numSettCons') + ')' }}
                  </div>
                </div>

                <div class="row row-custom">
                  <div class="prodotto-label col-5 no-padding">
                    {{ $t('dettaglioOfferta.qtaForn') }}
                  </div>
                  <div class="col-6">
                    <input v-model="formProdotto[item.codPos].qtaForn" :disabled="disabled || (item.ifRiaperto === '0' && testata.variante !== '0')"
                              @focus="focusCheck(item.codPos)" class="custom-input-standard"
                              v-on:change="changeRow(item.codPos)">
                  </div>

                  <div class="prodotto-label col-2 no-padding">
                    {{ $t('dettaglioOfferta.uMis') }}
                  </div>
                  <div class="col-9 u-mis">
                    <el-select v-model="formProdotto[item.codPos].codUMisForn"
                              :disabled="disabled || (item.ifRiaperto === '0' && testata.variante !== '0') || (parseInt(item.codProd) >= 9000000)"
                              @focus="focusCheck(item.codPos)" class="custom-select-el"
                              v-on:change="changeRow(item.codPos)" placeholder="">
                      <el-option
                        v-for="item in uMis[item.codUMis]"
                        :key="returnUMisKey(item)"
                        :label="item.codUMisConv + ' - ' + item.desUMisConv"
                        :value="item.codUMisConv">
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="row row-custom">
                  <div class="prodotto-label col-5 no-padding">
                    <span v-if="(!formProdotto[item.codPos].codConOffT || formProdotto[item.codPos].codConOff === formProdotto[item.codPos].codConOffT)">{{ $t('dettaglioOfferta.condOfferta') }}</span>
                    <el-tooltip class="item" effect="dark" :content="($t('dettaglioOfferta.valPrecedente') + ': ' + (formProdotto[item.codPos].codConOff ? formProdotto[item.codPos].codConOff : ''))" placement="top" v-else>
                      <span>{{ $t('dettaglioOfferta.condOfferta') }}</span>
                    </el-tooltip>
                  </div>
                  <div class="col-17">
                    <el-select v-model="formProdotto[item.codPos].codConOffT_2" placeholder=""
                              v-if="(!formProdotto[item.codPos].codConOffT || formProdotto[item.codPos].codConOff === formProdotto[item.codPos].codConOffT)"
                              v-on:change="changeRow(item.codPos)" :clearable="true" class="custom-select-el"
                              @focus="focusCheck(item.codPos)" :disabled="disabled || (item.ifRiaperto === '0' && testata.variante !== '0')">
                      <el-option
                        v-for="item in condizioniOfferta"
                        :key="item.codConOff"
                        :label="item.desConOff"
                        :value="item.codConOff">
                      </el-option>
                    </el-select>
                    <el-select v-model="formProdotto[item.codPos].codConOffT_2" placeholder=""
                              v-else
                              v-on:change="changeRow(item.codPos)" :clearable="true" class="custom-select-el select-el-modificato"
                              @focus="focusCheck(item.codPos)" :disabled="disabled">
                      <el-option
                        v-for="item in condizioniOfferta"
                        :key="item.codConOff"
                        :label="item.desConOff"
                        :value="item.codConOff">
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="row row-custom">
                  <div class="prodotto-label col-5 no-padding">
                    {{ $t('dettaglioOfferta.note') }}
                  </div>
                  <div class="col-17">
                    <el-input type="textarea" resize="none" v-model="formProdotto[item.codPos].notaRiga"
                              :disabled="disabled || (item.ifRiaperto === '0' && testata.variante !== '0')" :maxlength="35" class="custom-input"
                              v-on:change.native="changeRow(item.codPos)"
                              @focus="focusCheck(item.codPos)"></el-input>
                  </div>
                </div>
              </div>

              <div class="nota-fornitore-label">
                {{ $t('dettaglioOfferta.noteFornitore') }}
              </div>
              <div class="nota-fornitore-value">
                {{ item.notaFT }}
              </div>

            </div>

          </el-carousel-item>
        </el-carousel>

      </div>
    </div>

    <div class="bottoni col-24">
      <el-button size="small" @click="salva('C', true)" :disabled="disabled" :loading="saveDisabled" class="custom-button" >
        {{ $t('dettaglioOfferta.cancella').toUpperCase() }}
      </el-button>
      <el-button
        v-if="offerta.variante === '0'"
        size="small" @click="salva('S', true)" :disabled="disabled" :loading="saveDisabled" class="custom-button" type="primary"
      >
        {{ $t('dettaglioOfferta.salva').toUpperCase() }}
      </el-button>
      <el-button size="small" @click="openIfSalvaInvia" :disabled="disabled" :loading="saveDisabled" class="custom-button" type="primary">
        {{ $t('dettaglioOfferta.salvaInvia').toUpperCase() }}
      </el-button>
    </div>

    <el-dialog class="disegni-modal" :title="$t('dettaglioOfferta.disegniARicambio').toUpperCase()"
               :visible.sync="showDisegniModal" :append-to-body="true"
               custom-class="custom-dialog offset-xl-6 col-xl-12 offset-lg-4 col-lg-16 offset-md-2 col-md-20 offset-sm-2 col-sm-20 offset-0 col-24">

      <div class="prodotto">
        <span class="cod-prod">{{ disegniCodProd }}</span>
        <span class="des-prod">{{ ' - ' + disegniDescProd }}</span>
      </div>

      <el-table :data="disegni" class="custom-table">
        <el-table-column
          :label="($t('dettaglioOfferta.nrDisegnoTes'))"
          prop="nrTes"
          min-width="130">
        </el-table-column>
        <el-table-column
          prop="formatoDis"
          :label="$t('dettaglioOfferta.formatoDis')"
          min-width="60">
        </el-table-column>
        <el-table-column
          prop="tipoAllegato"
          :label="$t('dettaglioOfferta.tipoAllegato')"
          min-width="60">
        </el-table-column>
        <el-table-column
          width="45">

          <template slot-scope="scope">
            <div class="icone-wrapper actions">
              <icon name="riv-downloadPas" class="pointer" scale="1" @click.native="getDisegno(scope.row)"></icon>
            </div>
          </template>

        </el-table-column>

      </el-table>

    </el-dialog>

    <el-dialog class="last-offer-modal" :title="$t('dettaglioOfferta.titoloLastOffer').toUpperCase()"
               :visible.sync="showLastOffer" :append-to-body="true"
               custom-class="custom-dialog offset-xl-7 col-xl-10 offset-lg-6 col-lg-12 offset-md-4 col-md-16 offset-sm-2 col-sm-20 offset-1 col-22">

      <el-tabs type="card" class="custom-tabs">
        <el-tab-pane>
          <div slot="label">
            <div class="col-24 no-padding">
              {{ $t('dettaglioOfferta.ultimaOfferta') }}
            </div>
            <div class="col-24 no-padding barra"></div>
          </div>
          <div class="row row-custom">
            <div class="col-12 col-sx">
              <div class="lastoffer-label col-24 no-padding">
                {{ $t('dettaglioOfferta.posizione') }}
              </div>
              <div class="lastoffer-label col-24 no-padding">
                {{ $t('dettaglioOfferta.prodotto') }}
              </div>
              <div class="lastoffer-label col-24 no-padding">
                {{ $t('dettaglioOfferta.descrizione') }}
              </div>
              <div class="lastoffer-label col-24 no-padding">
                {{ $t('dettaglioOfferta.prodRif') }}
              </div>
              <div class="lastoffer-label col-24 no-padding">
                {{ $t('dettaglioOfferta.prezzoUnitario') }}
              </div>
              <div class="lastoffer-label col-24 no-padding">
                {{ $t('dettaglioOfferta.scPerc1') }}
              </div>
              <div class="lastoffer-label col-24 no-padding">
                {{ $t('dettaglioOfferta.scPerc2') }}
              </div>
              <div class="lastoffer-label col-24 no-padding">
                {{ $t('dettaglioOfferta.vsOfferta') }}
              </div>
              <div class="lastoffer-label col-24 no-padding">
                {{ $t('dettaglioOfferta.del') }}
              </div>
            </div>
            <div class="col-12 col-dx">
              <div class="lastoffer-value col-24 no-padding">
                {{ lastOfferProdotto.codPos | formatString }}
              </div>
              <div class="lastoffer-value col-24 no-padding">
                {{ lastOfferProdotto.codProd | formatString }}
              </div>
              <div class="lastoffer-value col-24 no-padding">
                {{ lastOfferProdotto.desProd | formatString }}
              </div>
              <div class="lastoffer-value col-24 no-padding">
                {{ lastOfferProdotto.codProdRif | formatString }}
              </div>
              <div class="lastoffer-value col-24 no-padding">
                {{ lastOfferProdotto.przUniLO | formatString }}
              </div>
              <div class="lastoffer-value col-24 no-padding">
                {{ lastOfferProdotto.scPerc1LO | formatString }}
              </div>
              <div class="lastoffer-value col-24 no-padding">
                {{ lastOfferProdotto.scPerc2LO | formatString }}
              </div>
              <div class="lastoffer-value col-24 no-padding">
                {{ lastOfferProdotto.rifCofLO | formatString }}
              </div>
              <div class="lastoffer-value col-24 no-padding">
                {{ lastOfferProdotto.datRifCofLO | formatDate }}
              </div>
            </div>
          </div>

          <div class="bottone-riporta col-24 no-padding">
            <el-button @click="riportaOfferta" type="primary" class="custom-button">{{ $t('dettaglioOfferta.riporta').toUpperCase() }}</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane>
          <div slot="label">
            <div class="col-24 no-padding">
              {{ $t('dettaglioOfferta.ultimoOrdine') }}
            </div>
            <div class="col-24 no-padding barra"></div>
          </div>
          <div class="row row-custom">
            <div class="col-12 col-sx">
              <div class="lastoffer-label col-24 no-padding">
                {{ $t('dettaglioOfferta.posizione') }}
              </div>
              <div class="lastoffer-label col-24 no-padding">
                {{ $t('dettaglioOfferta.prodotto') }}
              </div>
              <div class="lastoffer-label col-24 no-padding">
                {{ $t('dettaglioOfferta.descrizione') }}
              </div>
              <div class="lastoffer-label col-24 no-padding">
                {{ $t('dettaglioOfferta.prodRif') }}
              </div>
              <div class="lastoffer-label col-24 no-padding">
                {{ $t('dettaglioOfferta.prezzoUnitario') }}
              </div>
              <div class="lastoffer-label col-24 no-padding">
                {{ $t('dettaglioOfferta.scPerc1') }}
              </div>
              <div class="lastoffer-label col-24 no-padding">
                {{ $t('dettaglioOfferta.scPerc2') }}
              </div>
              <div class="lastoffer-label col-24 no-padding">
                {{ $t('dettaglioOfferta.numOrdine') }}
              </div>
              <div class="lastoffer-label col-24 no-padding">
                {{ $t('dettaglioOfferta.del') }}
              </div>
            </div>
            <div class="col-12 col-dx">
              <div class="lastoffer-value col-24 no-padding">
                {{ lastOfferProdotto.codPos | formatString }}
              </div>
              <div class="lastoffer-value col-24 no-padding">
                {{ lastOfferProdotto.codProd | formatString }}
              </div>
              <div class="lastoffer-value col-24 no-padding">
                {{ lastOfferProdotto.desProd | formatString }}
              </div>
              <div class="lastoffer-value col-24 no-padding">
                {{ lastOfferProdotto.codProdRif | formatString }}
              </div>
              <div class="lastoffer-value col-24 no-padding">
                {{ lastOfferProdotto.przUniLOrd | formatString }}
              </div>
              <div class="lastoffer-value col-24 no-padding">
                {{ lastOfferProdotto.scPerc1LOrd | formatString }}
              </div>
              <div class="lastoffer-value col-24 no-padding">
                {{ lastOfferProdotto.scPerc2LOrd | formatString }}
              </div>
              <div class="lastoffer-value col-24 no-padding">
                {{ lastOfferProdotto.numOrdLOrd | formatString }}
              </div>
              <div class="lastoffer-value col-24 no-padding">
                {{ lastOfferProdotto.datOrdLOrd | formatDate }}
              </div>
            </div>
          </div>

          <div class="col-24 no-padding bottone-riporta">
            <el-button @click="riportaOrdine" type="primary" class="custom-button">{{ $t('dettaglioOfferta.riporta').toUpperCase() }}</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>

    </el-dialog>

    <el-dialog class="modal-check" :title="$t('dettaglioOfferta.titoloCheckSizeError').toUpperCase()"
               :visible.sync="showCheckSizeError" :append-to-body="true"
               custom-class="custom-dialog offset-xl-7 col-xl-10 offset-lg-6 col-lg-12 offset-md-4 col-md-16 offset-sm-2 col-sm-20 offset-1 col-22">

      <div class="msg">
        {{ $t('dettaglioOfferta.msgErrorSizeModified') }}
      </div>

      <span slot="footer" class="footer">
        <div>
          <el-button @click="closeCheckSizeError(false)" class="custom-button">
            {{ $t('dettaglioOfferta.annullaIgnora').toUpperCase() }}
          </el-button>
          <el-button @click="closeCheckSizeError(true)" class="custom-button" type="primary">
            {{ $t('dettaglioOfferta.salva').toUpperCase() }}
          </el-button>
        </div>
      </span>

    </el-dialog>

    <el-dialog class="modal-check" :title="$t('dettaglioOfferta.attenzione').toUpperCase()"
               :visible.sync="showContinua" :append-to-body="true"
               custom-class="custom-dialog offset-xl-8 col-xl-8 offset-lg-8 col-lg-10 offset-md-6 col-md-12 offset-sm-3 col-sm-18 offset-1 col-22">

      <div class="msg">
        <span v-if="(testata.ifSalvaInvia === '0' && testata.ifDocObblig === 'S')">
          {{ $t('dettaglioOfferta.nonInRegola') }}
        </span>
        <span v-if="(testata.ifSalvaInvia === '1' && testata.ifDocObblig === 'S')">
          {{ $t('dettaglioOfferta.controlloSchedeSic') }}
        </span>
        <span v-if="(testata.ifSalvaInvia === '1' && testata.ifDocObblig === '')">
          {{ $t('dettaglioOfferta.continuare') }}
        </span>
      </div>

      <span slot="footer" class="footer">
        <div class="bottoni" v-if="(testata.ifSalvaInvia === '0' && testata.ifDocObblig === 'S')">
          <el-button @click="(showContinua = false)" type="primary" class="custom-button">
            {{ $t('dettaglioOfferta.ok').toUpperCase() }}
          </el-button>
        </div>

        <div class="bottoni" v-if="(testata.ifSalvaInvia === '1' && testata.ifDocObblig === 'S')">
          <el-button @click="openSchedeSicKO" class="custom-button">
            {{ $t('dettaglioOfferta.no').toUpperCase() }}
          </el-button>
          <el-button @click="salva('I', true)" :loading="saveDisabled" type="primary" class="custom-button">
            {{ $t('dettaglioOfferta.si').toUpperCase() }}
          </el-button>
        </div>

        <div class="bottoni" v-if="(testata.ifSalvaInvia === '1' && testata.ifDocObblig === '')">
          <el-button @click="(showContinua = false)" class="custom-button">
            {{ $t('dettaglioOfferta.annulla').toUpperCase() }}
          </el-button>
          <el-button @click="salva('I', true)" :loading="saveDisabled" type="primary" class="custom-button">
            {{ $t('dettaglioOfferta.salvaInvia').toUpperCase() }}
          </el-button>
        </div>
      </span>

    </el-dialog>

    <el-dialog class="modal-documenti" :title="$t('dettaglioOfferta.documentiProdottoTitolo').toUpperCase() + ' ' + prodottoSelectedDoc.codProd + ' - ' + prodottoSelectedDoc.desProd"
               :visible.sync="ifDocumentiVisible" :append-to-body="true" @close="closeDocumenti"
               custom-class="custom-dialog offset-xl-4 col-xl-16 offset-lg-1 col-lg-22 offset-0 col-24">

      <div class="upload">
        <div>
          <div class="tipo-doc-label">
            {{ $t('dettaglioOfferta.tipoDocumento') + ': ' }}
          </div>
          <el-select v-model="tipoDocSelected" class="custom-select-el">
            <el-option
              v-for="item in tipiDoc"
              :key="item.codTipoDoc"
              :label="item.desTipoDoc"
              :value="item.codTipoDoc">
            </el-option>
          </el-select>
        </div>

        <div class="upload-file">
          <el-upload
            class="upload-demo" accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, .xlsx"
            :on-change="changeUploadList" :on-exceed="handleExceed"
            :multiple="false" action="" :limit="1" :on-remove="handleRemove"
            :auto-upload="false" ref="uploadDoc">
            <el-button size="mini" :disabled="(uploadList.length > 0)" class="custom-button">
              {{ $t('dettaglioOfferta.scegli') }}
            </el-button>
          </el-upload>
          <div class="bottoni">
            <el-button size="small" @click="uploadDoc" type="primary" class="custom-button"
                          :disabled="(uploadList.length === 0 || tipoDocSelected === '' || disabled)"
                          :loading="loadingDoc">
              {{ $t('dettaglioOfferta.upload').toUpperCase() }}
            </el-button>
          </div>
        </div>
      </div>
      <!--
      <div class="documenti-caricati-title">
        {{ $t('dettaglioOfferta.documentiCaricati').toUpperCase() }}
      </div>
      -->
      <div class="tabella-documenti" v-loading="loadingDoc">
        <el-table :data="documenti" class="custom-table">
          <el-table-column
            width="15"
            class-name="cell-no-padding-left"
          >

            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="(scope.row.desConformita)" placement="top">
                <div :class="['cerchio', (scope.row.colConformita === '0') ? 'verde' : ((scope.row.colConformita === '1') ? 'rosso' : 'giallo')]"></div>
              </el-tooltip>
            </template>

          </el-table-column>
          <el-table-column
            :label="($t('dettaglioOfferta.idDocumento'))"
            prop="keyDoc"
            width="245">
          </el-table-column>
          <el-table-column
            prop="nomeDoc"
            :label="$t('dettaglioOfferta.nomeFile')"
            min-width="140">
          </el-table-column>
          <el-table-column
            :label="$t('dettaglioOfferta.tipoDocumento')"
            width="180">

            <template slot-scope="scope">
              {{ (scope.row.idApp === 'FORSCHSIC') ? $t('dettaglioOfferta.schedaSicurezza').toUpperCase() : '' }}
              {{ (scope.row.idApp === 'FORDATSHE') ? $t('dettaglioOfferta.dataSheet').toUpperCase() : '' }}
            </template>

          </el-table-column>
          <el-table-column
            header-align="center" align="center"
            :label="$t('dettaglioOfferta.dataCaricamento')"
            width="155">

            <template slot-scope="scope">
              {{ moment(scope.row.dataDoc, 'DDMMYYYY').format('DD/MM/YYYY') }}
            </template>

          </el-table-column>
          <el-table-column
            width="65">

            <template slot-scope="scope">
              <div class="icone-wrapper actions">
                <div class="row row-custom">
                  <div class="col-12 no-padding">
                    <icon name="riv-downloadPas" class="pointer" scale="1" @click.native="getDoc(scope.row)"></icon>
                  </div>
                  <div class="col-12 no-padding" style="text-align: right">
                    <icon name="riv-delete_2" v-if="(scope.row.ifElimina === '1')" class="pointer" scale="1" @click.native="deleteDoc(scope.row)"></icon>
                  </div>
                </div>
              </div>
            </template>

          </el-table-column>

        </el-table>
      </div>

    </el-dialog>

    <el-dialog class="modal-documenti" :title="$t('dettaglioOfferta.documentiOffertaTitolo').toUpperCase() + ' ' + offerta.numRif"
               :visible.sync="ifDocumentiOffertaVisible" :append-to-body="true" @close="closeDocumentiOfferta"
               custom-class="custom-dialog offset-xl-4 col-xl-16 offset-lg-1 col-lg-22 offset-0 col-24">

      <div class="upload">
        <div>
          <div class="tipo-doc-label">
            {{ $t('dettaglioOfferta.tipoDocumento') + ': ' }}
          </div>
          <el-select v-model="tipoDocOffertaSelected" class="custom-select-el">
            <el-option
              v-for="item in tipiDocOfferta"
              :key="item.codTipoDoc"
              :label="item.desTipoDoc"
              :value="item.codTipoDoc">
            </el-option>
          </el-select>
        </div>

        <div class="upload-file">
          <el-upload
            class="upload-demo" accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, .xlsx"
            :on-change="changeUploadListOfferta" :on-exceed="handleExceed"
            :multiple="false" action="" :limit="1" :on-remove="handleRemoveOfferta"
            :auto-upload="false" ref="uploadDocOfferta">
            <el-button size="mini" :disabled="(uploadListOfferta.length > 0)" class="custom-button">
              {{ $t('dettaglioOfferta.scegli') }}
            </el-button>
          </el-upload>
          <div class="bottoni">
            <el-button size="small" @click="uploadDocOfferta" type="primary" class="custom-button"
                          :disabled="(uploadListOfferta.length === 0 || tipoDocOffertaSelected === '' || disabled)"
                          :loading="loadingDoc">
              {{ $t('dettaglioOfferta.upload').toUpperCase() }}
            </el-button>
          </div>
        </div>
      </div>
      <!--
      <div class="documenti-caricati-title">
        {{ $t('dettaglioOfferta.documentiCaricati').toUpperCase() }}
      </div>
      -->
      <div class="tabella-documenti" v-loading="loadingDoc">
        <el-table :data="documentiOfferta" class="custom-table">
          <el-table-column
            width="15"
            class-name="cell-no-padding-left"
          >

            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="(scope.row.desConformita)" placement="top">
                <div :class="['cerchio', (scope.row.colConformita === '0') ? 'verde' : ((scope.row.colConformita === '1') ? 'rosso' : 'giallo')]"></div>
              </el-tooltip>
            </template>

          </el-table-column>
          <el-table-column
            :label="($t('dettaglioOfferta.idDocumento'))"
            prop="keyDoc"
            width="245">
          </el-table-column>
          <el-table-column
            prop="nomeDoc"
            :label="$t('dettaglioOfferta.nomeFile')"
            min-width="140">
          </el-table-column>
          <el-table-column
            :label="$t('dettaglioOfferta.tipoDocumento')"
            width="220">

            <template slot-scope="scope">
              {{ scope.row.desTipoDoc }}
            </template>

          </el-table-column>
          <el-table-column
            header-align="center" align="center"
            :label="$t('dettaglioOfferta.dataCaricamento')"
            width="155">

            <template slot-scope="scope">
              {{ moment(scope.row.dataDoc, 'DDMMYYYY').format('DD/MM/YYYY') }}
            </template>

          </el-table-column>
          <el-table-column
            width="65">

            <template slot-scope="scope">
              <div class="icone-wrapper actions">
                <div class="row row-custom">
                  <div class="col-12 no-padding">
                    <icon name="riv-downloadPas" class="pointer" scale="1" @click.native="getDoc(scope.row)"></icon>
                  </div>
                  <div class="col-12 no-padding" style="text-align: right">
                    <icon name="riv-delete_2" v-if="(scope.row.ifElimina === '1')" class="pointer" scale="1" @click.native="deleteDocOfferta(scope.row)"></icon>
                  </div>
                </div>
              </div>
            </template>

          </el-table-column>

        </el-table>
      </div>

    </el-dialog>

    <el-dialog class="modal-trattativa" :title="$t('dettaglioOfferta.trattativa').toUpperCase()"
               :visible.sync="showTrattativa" :append-to-body="true"
               custom-class="custom-dialog offset-xl-2 col-xl-20 offset-lg-1 col-lg-22 offset-0 col-24">

      <div class="prodotto col-24">
        <div class="cod-prod">
          {{ prodTrattativa.codProd }}
        </div>
        <div class="qta-prod">
          {{ prodTrattativa.numQta + ' ' + prodTrattativa.codUMis }}
        </div>
        <div class="des-prod">
          {{ prodTrattativa.desProd }}
        </div>
      </div>

      <div class="col-24 storico">
        <div class="col-24 no-padding titolo">
          {{ $t('dettaglioOfferta.storico') }}
        </div>

        <el-table :data="storico" class="custom-table" v-loading="loadingStorico">

          <el-table-column
            width="90" align="left"
          >
            <template slot-scope="scope">
              <div class="row row-custom" :key="scope.$index">
                <div class="col-24 no-padding">
                  {{ $t('dettaglioOfferta.fornitore') }}
                </div>
                <div class="col-24 no-padding">
                  {{ $t('dettaglioOfferta.uffAcq') }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="110" header-align="center" align="center"
            :label="($t('dettaglioOfferta.storicoOfferta'))"
          >
            <template slot-scope="scope">
              <div class="col-24 no-padding">
                {{
                  scope.row.dataForn ? moment(scope.row.dataForn, 'DDMMYYYY').format('DD/MM/YYYY') + ' ' + moment(scope.row.oraForn, 'HHmm').format('HH:mm') : '&nbsp;'
                }}
              </div>
              <div class="col-24 no-padding">
                {{
                  scope.row.data ? moment(scope.row.data, 'DDMMYYYY').format('DD/MM/YYYY') + ' ' + moment(scope.row.ora, 'HHmm').format('HH:mm') : '&nbsp;'
                }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="60" align="center" :label="($t('dettaglioOfferta.prezzo'))"
          >
            <template slot-scope="scope">
              <div class="row row-custom">
                <div class="col-24 no-padding">
                  {{ (scope.row.dataForn && scope.row.przForn) ? scope.row.przForn : '&nbsp;' }}
                </div>
                <div class="col-24 no-padding">
                  {{ (scope.row.data && scope.row.prz) ? scope.row.prz : '&nbsp;' }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="35" align="center"
          >
           <template slot-scope="scope">
              <div class="row row-custom">
                <div class="col-24 no-padding">
                  {{ (scope.row.dataForn && scope.row.divisa) ? scope.row.divisa : '&nbsp;' }}
                </div>
                <div class="col-24 no-padding">
                  {{ (scope.row.data && scope.row.divisa) ? scope.row.divisa : '&nbsp;' }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="55" align="center" :label="($t('dettaglioOfferta.qta'))"
          >
            <template slot-scope="scope">
              <div class="row row-custom">
                <div class="col-24 no-padding">
                  {{ (scope.row.dataForn && scope.row.qtaTForn) ? scope.row.qtaTForn : '&nbsp;' }}
                </div>
                <div class="col-24 no-padding">
                  {{ (scope.row.data && scope.row.qtaT) ? scope.row.qtaT : '&nbsp;' }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="75" header-align="center" align="center"
            :label="$t('dettaglioOfferta.storicoSconto') + '1(%)'"
          >
            <template slot-scope="scope">
              <div class="row row-custom">
                <div class="col-24 no-padding">
                  {{ (scope.row.dataForn && scope.row.scPerc1Forn) ? scope.row.scPerc1Forn : '&nbsp;' }}
                </div>
                <div class="col-24 no-padding">
                  {{ (scope.row.data && scope.row.scPerc1) ? scope.row.scPerc1 : '&nbsp;' }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="75" header-align="center" align="center"
            :label="$t('dettaglioOfferta.storicoSconto') + '2(%)'"
          >
            <template slot-scope="scope">
              <div class="row row-custom">
                <div class="col-24 no-padding">
                  {{ (scope.row.dataForn && scope.row.scPerc2Forn) ? scope.row.scPerc2Forn : '&nbsp;' }}
                </div>
                <div class="col-24 no-padding">
                  {{ (scope.row.data && scope.row.scPerc2) ? scope.row.scPerc2 : '&nbsp;' }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="80" header-align="center" align="center"
            :label="$t('dettaglioOfferta.consegna')"
          >
            <template slot-scope="scope">
              <div class="row row-custom">
                <div class="col-24 no-padding">
                  {{ (scope.row.dataForn && scope.row.numSettCons) ? scope.row.numSettCons : '&nbsp;' }}
                </div>
                <div class="col-24 no-padding">
                  {{ (scope.row.data && scope.row.numSettCons) ? scope.row.numSettCons : '&nbsp;' }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="90" header-align="center" align="center"
            :label="$t('dettaglioOfferta.qtaForn')"
          >
            <template slot-scope="scope">
              <div class="row row-custom">
                <div class="col-24 no-padding">
                  {{ (scope.row.dataForn && scope.row.qtaForn) ? scope.row.qtaForn : '&nbsp;' }}
                </div>
                <div class="col-24 no-padding">
                  {{ (scope.row.data && scope.row.qtaForn) ? scope.row.qtaForn : '&nbsp;' }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="60" header-align="center" align="center"
            :label="$t('dettaglioOfferta.uMis')"
          >
            <template slot-scope="scope">
              <div class="row row-custom">
                <div class="col-24 no-padding">
                  {{ (scope.row.dataForn && scope.row.UMisForn) ? scope.row.UMisForn : '&nbsp;' }}
                </div>
                <div class="col-24 no-padding">
                  {{ (scope.row.data && scope.row.UMisForn) ? scope.row.UMisForn : '&nbsp;' }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="105" header-align="center" align="center"
            :label="$t('dettaglioOfferta.condOfferta')"
          >
            <template slot-scope="scope">
              <div class="row row-custom">
                <div class="col-24 no-padding">
                  <el-tooltip class="item" effect="dark" :content="scope.row.desConOffForn" placement="top" :disabled="!(scope.row.dataForn && scope.row.codConOffForn)">
                    <span>{{ (scope.row.dataForn && scope.row.codConOffForn) ? scope.row.codConOffForn : '&nbsp;' }}</span>
                  </el-tooltip>
                </div>
                <div class="col-24 no-padding">
                  <el-tooltip class="item" effect="dark" :content="scope.row.desConOff" placement="top" :disabled="!(scope.row.data && scope.row.codConOff)">
                    <span>{{ (scope.row.data && scope.row.codConOff) ? scope.row.codConOff : '&nbsp;' }}</span>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="85" header-align="center" align="center"
            :label="$t('dettaglioOfferta.resa')"
          >
            <template slot-scope="scope">
              <div class="row row-custom">
                <div class="col-24 no-padding">
                  <el-tooltip class="item" effect="dark" :content="scope.row.desResaForn" placement="top" :disabled="!(scope.row.dataForn && scope.row.codResaForn)">
                    <span>{{ (scope.row.dataForn && scope.row.codResaForn) ? scope.row.codResaForn : '&nbsp;' }}</span>
                  </el-tooltip>
                </div>
                <div class="col-24 no-padding">
                  <el-tooltip class="item" effect="dark" :content="scope.row.desResa" placement="top" :disabled="!(scope.row.data && scope.row.codResa)">
                    <span>{{ (scope.row.data && scope.row.codResa) ? scope.row.codResa : '&nbsp;' }}</span>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="75" header-align="center" align="center"
            :label="$t('dettaglioOfferta.trasporto')"
          >
            <template slot-scope="scope">
              <div class="row row-custom">
                <div class="col-24 no-padding">
                  {{ (scope.row.dataForn && scope.row.costTraspForn) ? scope.row.costTraspForn : '&nbsp;' }}
                </div>
                <div class="col-24 no-padding">
                  {{ (scope.row.data && scope.row.costTrasp) ? scope.row.costTrasp : '&nbsp;' }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="75" header-align="center" align="center"
            :label="$t('dettaglioOfferta.imballo')"
          >
            <template slot-scope="scope">
              <div class="row row-custom">
                <div class="col-24 no-padding">
                  {{ (scope.row.dataForn && scope.row.costImbalForn) ? scope.row.costImbalForn : '&nbsp;' }}
                </div>
                <div class="col-24 no-padding">
                  {{ (scope.row.data && scope.row.costImbal) ? scope.row.costImbal : '&nbsp;' }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="85" header-align="center" align="center"
            :label="$t('dettaglioOfferta.pagamento')"
          >
            <template slot-scope="scope">
              <div class="row row-custom">
                <div class="col-24 no-padding">
                  <el-tooltip class="item" effect="dark" :content="scope.row.desPagForn" placement="top" :disabled="!(scope.row.dataForn && scope.row.codPagForn)">
                    <span>{{ (scope.row.dataForn && scope.row.codPagForn) ? scope.row.codPagForn : '&nbsp;' }}</span>
                  </el-tooltip>
                </div>
                <div class="col-24 no-padding">
                  <el-tooltip class="item" effect="dark" :content="scope.row.desPag" placement="top" :disabled="!(scope.row.data && scope.row.codPag)">
                    <span>{{ (scope.row.data && scope.row.codPag) ? scope.row.codPag : '&nbsp;' }}</span>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>

        </el-table>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  import {bus} from '@/components/Bus.js'
  import moment from 'moment'

  export default {
    components: {},
    name: 'DettaglioOfferta',
    filters: {
      formatDate: function (date) {
        if (date !== undefined && date !== '') {
          return date.substr(0, 2) + '/' + date.substr(2, 2) + '/' + date.substr(4, 4)
        } else {
          return '-'
        }
      },
      formatString : function (string) {
        if (string === '' || string === undefined) {
          return '-'
        } else {
          return string
        }
      },
      truncate: function (string) {
        if (string.length > 150) {
          return string.substr(0, 150) + '...'
        } else {
          return string
        }
      }
    },
    i18n: {
      messages: {
        it_IT: {
          dettaglioOfferta: {
            offerta: 'Richiesta di Offerta Nr. ',
            del: 'del',
            validaFino: 'Valida fino',
            prodotto: 'Prodotto',
            qta: 'Qtà',
            descrizione: 'Descrizione',
            email: 'Mail',
            trasporto: 'Trasporto',
            imballo: 'Imballo',
            prezzo: 'Prezzo',
            posizione: 'Posizione',
            prodRif: 'Prod. Rif.',
            prezzoUnitario: 'Prezzo Unitario',
            vsOfferta: 'Vs. Offerta',
            riporta: 'Riporta',
            titoloLastOffer: 'Condizioni ultima offerta o ultimo ordine',
            ok: 'Ok',
            cancella: 'Elimina',
            titoloCheckConsegna: 'Richiesta d\'Offerta',
            salva: 'Salva',
            salvaInvia: 'Salva e Invia',
            elimina: 'Elimina',
            erroreParametro: 'Dati errati o mancanti',
            erroreParametroDettaglio: 'Errore',
            pagina: 'pagina',
            rifCof: 'Vs. Riferimento',
            przUni: 'Prezzo',
            datRifCof: 'Data Vs. Riferimento',
            notaTes: 'Nota testata',
            indEmail: 'Email',
            costTrasp: 'Costo Trasporto',
            costImbal: 'Costo Imballo',
            numGgCons: 'Numero giorni consegna dall\'ordine',
            datCons: 'Data Consegna',
            scPerc1: 'Sconto 1',
            scPerc2: 'Sconto 2',
            erroreDataNumGg: 'Inserire o una data consegna o i giorni dall\'ordine',
            titoloCheckSizeError: 'Salvataggio parziale',
            msgErrorSizeModified: 'Si è raggiunto il limite massimo di 50 righe modificate, prima di procedere con le altre salvare le modifiche attuali.',
            noteFornitore: 'Note per Fornitore',
            consegna: 'Consegna',
            numSettCons: 'Settimane dall\'Ordine',
            note: 'Note',
            condOfferta: 'Cond. Offerta',
            leggiTutto: 'Mostra altro...',
            leggiMeno: 'Mostra meno...',
            resa: 'Resa',
            pagamento: 'Pagamento',
            qtaForn: 'Qta Forn.',
            uMis: 'U. M.',
            ultimaOfferta: 'Ultima Offerta',
            ultimoOrdine: 'Ultimo Ordine',
            numOrdine: 'Numero Ordine',
            lastOfferOrder: 'Condizioni ultimo Ordine/Offerta',
            annulla: 'Annulla',
            continuare: 'Sei sicuro di voler proseguire?',
            attenzione: 'Attenzione',
            errorFormatMail: 'Formato mail non valido',
            disegniARicambio: 'Disegno tecnico',
            nrDisegnoTes: 'Codice Disegno',
            formatoDis: 'Formato',
            tipoAllegato: 'Tipo Allegato',
            divisa: 'Valuta',
            upload: 'Upload',
            documentiProdotto: 'Documenti Prodotto',
            idDocumento: 'ID Documento',
            nomeFile: 'Nome File',
            tipoDocumento: 'Tipo Documento',
            dataCaricamento: 'Data Caricamento',
            schedaSicurezza: 'Scheda di Sicurezza',
            scegli: 'Scegli...',
            documentiCaricati: 'Documenti Caricati',
            rosso: 'Scheda di Sicurezza Mancante/Non Conforme',
            giallo: 'Scheda di Sicurezza in Approvazione',
            verde: 'Scheda di Sicurezza Conforme',
            caricamentoOK: 'Documento salvato correttamente',
            caricamentoKO: 'Errore di caricamento',
            nonInRegola: 'Una o più schede di sicurezza risultano essere mancanti o quelle in ns. possesso non sono conformi. Per favore verifichi e aggiorni l\'offerta',
            controlloSchedeSic: 'Confermi che le schede in nostro possesso sono relative ai prodotti offerti?',
            verificaDocumenti: 'Ti preghiamo di verificare e aggiornare i documenti. Grazie',
            si: 'Sì',
            no: 'No',
            annullaIgnora: 'Annulla',
            dataSheet: 'Data Sheet',
            trattativa: 'Negoziazione',
            ufficioAcquisti: 'Ufficio Acquisti',
            fornitore: 'Fornitore',
            conferma: 'Conferma',
            storico: 'Storico',
            prezzoRichiesto: 'Prezzo Richiesto',
            qtaRichiesta: 'Qta Richiesta',
            accetta: 'Accetta',
            rifiuta: 'Rifiuta',
            uffAcq: 'Uff. Acq.',
            storicoOfferta: 'Offerta',
            storicoSconto: 'Sct',
            verificaProdRiaperti: 'Negoziazione non completa',
            prodotti: 'Prodotti',
            documentiOfferta: 'Documenti Offerta',
            documentiOffertaTitolo: 'Documenti: Offerta Nr.',
            documentiProdottoTitolo: 'Documenti: Prodotto',
            valPrecedente: 'Valore precedente',
            valida: 'Accetta'
          }
        },
        fr_FR: {
          dettaglioOfferta: {
            offerta: 'Offre',
            del: 'du',
            validaFino: 'Valable jusqu\'à',
            prodotto: 'Produit',
            qta: 'Quantité',
            descrizione: 'Description',
            email: 'E-Mail',
            trasporto: 'Transport',
            imballo: 'Emballage',
            prezzo: 'Prix',
            posizione: 'Emplacement',
            prodRif: 'Réf. Prod.',
            prezzoUnitario: 'Prix unitaire',
            vsOfferta: 'Votre Offre',
            riporta: 'Rapport',
            titoloLastOffer: 'Conditions de la dernière offre ou dernière commande',
            ok: 'Ok',
            cancella: 'Clair',
            titoloCheckConsegna: 'Demande d\'Offre',
            salva: 'Enregistrer',
            salvaInvia: 'Enregistrer et Envoyer',
            elimina: 'Effacer',
            erroreParametro: 'Données erronées ou manquantes',
            erroreParametroDettaglio: 'Erreur',
            erroreDataNumGg: 'Remplissez la Date de Livraison ou les Jours',
            pagina: 'page',
            rifCof: 'Votre Référence',
            przUni: 'Prix',
            datRifCof: 'Date Votre Référence',
            notaTes: 'Note testée',
            indEmail: 'Email',
            costTrasp: 'Coût de Transport',
            costImbal: 'Coût de l\'Emballage',
            numGgCons: 'Nombre de jours de livraison de la commande',
            datCons: 'Date de Livraison',
            scPerc1: 'Remise 1',
            scPerc2: 'Remise 2',
            titoloCheckSizeError: 'Sauvegarde partielle',
            msgErrorSizeModified: 'Le nombre maximum de 50 lignes modifiées a été atteint, enregistrez les modifications actuelles avant de poursuivre.',
            noteFornitore: 'Note pour fournisseur',
            consegna: 'Livraison',
            numSettCons: 'Semaines à partir de la commande',
            note: 'Notes',
            condOfferta: 'Cond. Offertes',
            leggiTutto: 'Afficher plus...',
            leggiMeno: 'Afficher moins...',
            resa: 'Rendement',
            pagamento: 'Paiement',
            qtaForn: 'Qté Forn.',
            uMis: 'U. Mis.',
            ultimaOfferta: 'Dernière Offre',
            ultimoOrdine: 'Dernière Commande',
            numOrdine: 'Numéro de commande',
            lastOfferOrder: 'Conditions dernière Commande/Offre',
            annulla: 'Annuler',
            continuare: 'Êtes-vous sûr de vouloir continuer?',
            attenzione: 'Attention',
            errorFormatMail: 'Format de courrier invalide',
            disegniARicambio: 'Dessin Technique',
            nrDisegnoTes: 'Code de Conception',
            formatoDis: 'Format',
            tipoAllegato: 'Type de Pièce Jointe',
            divisa: 'Monnaie',
            upload: 'Upload',
            documentiProdotto: 'Documents produits',
            idDocumento: 'ID Document',
            nomeFile: 'Nom du Fichier',
            tipoDocumento: 'Type de Document',
            dataCaricamento: 'Date de Chargement',
            schedaSicurezza: 'Fiche de Sécurité',
            scegli: 'Choisir...',
            documentiCaricati: 'Documents Téléchargés',
            rosso: 'Fiche de données de sécurité manquante/non conforme',
            giallo: 'Fiche de données de sécurité en cours d\'approbation',
            verde: 'Fiche de données de sécurité conforme',
            caricamentoOK: 'Document enregistré avec succès',
            caricamentoKO: 'Erreur de téléchargement',
            nonInRegola: 'Une ou plusieurs fiches de  sécurité sont manquantes ou celles de notre possession ne sont pas conformes. Veuillez vérifier et mettre à jour l\'offre',
            controlloSchedeSic: 'Confirmez vous que les fiches de sécurité en notre possession sont liées aux produits proposés?',
            verificaDocumenti: 'Veuillez vérifier et mettre à jour les documents. Merci',
            si: 'Oui',
            no: 'Non',
            annullaIgnora: 'Annuler',
            dataSheet: 'Data Sheet',
            trattativa: 'Négociation',
            ufficioAcquisti: 'Bureau des Achats',
            fornitore: 'Fournisseur',
            conferma: 'Confirmation',
            storico: 'Historique',
            prezzoRichiesto: 'Prix Requis',
            qtaRichiesta: 'Qté de Demande',
            accetta: 'Accepter',
            rifiuta: 'Rejeter',
            uffAcq: 'Bureau Achats',
            storicoOfferta: 'Offre',
            storicoSconto: 'Rem',
            verificaProdRiaperti: 'La négociation n\'est pas terminée',
            prodotti: 'Produits',
            documentiOfferta: 'Documents de l\'Offre',
            documentiOffertaTitolo: 'Documents: Offre',
            documentiProdottoTitolo: 'Documents: Produit',
            valPrecedente: 'Valeur précédente',
            valida: 'Accepter'
          }
        },
        es_ES: {
          dettaglioOfferta: {
            offerta: 'Oferta',
            del: 'del',
            validaFino: 'Válido hasta',
            prodotto: 'Producto',
            qta: 'Cantidad',
            descrizione: 'Descripción',
            email: 'E-mail',
            trasporto: 'Transporte',
            imballo: 'Embalaje',
            prezzo: 'Precio',
            posizione: 'Posición',
            prodRif: 'Ref. Prod.',
            prezzoUnitario: 'Precio Unitario',
            vsOfferta: 'Su Oferta',
            riporta: 'Informe',
            titoloLastOffer: 'Últimas condiciones de oferta o ultima orden',
            ok: 'Ok',
            cancella: 'Elimina',
            titoloCheckConsegna: 'Peticiones de Oferta',
            salva: 'Guardar',
            salvaInvia: 'Guardar y Enviar',
            elimina: 'Borrar',
            erroreParametro: 'Datos erróneos o faltantes',
            erroreParametroDettaglio: 'Error',
            pagina: 'página',
            rifCof: 'Tu Referencia',
            przUni: 'Precio',
            datRifCof: 'Fecha Tu Referencia',
            notaTes: 'Nota probada',
            indEmail: 'E-mail',
            costTrasp: 'Costo de Transporte',
            costImbal: 'Costo de Empaque',
            numGgCons: 'Número de días de Entrega de la Orden',
            datCons: 'Fecha de Entrega',
            scPerc1: 'Descuento 1',
            scPerc2: 'Descuento 2',
            erroreDataNumGg: 'Ingrese una Fecha de Entrega o Días de la Orden',
            titoloCheckSizeError: 'Guardado parcial',
            msgErrorSizeModified: 'Se ha alcanzado el limite máximo de 50 líneas modificadas; antes de proceder con las otras debe guardar las modificaciones actuales.',
            noteFornitore: 'Notas para el Proveedor',
            consegna: 'Entrega',
            numSettCons: 'Semanas desde el pedido',
            note: 'Notas',
            condOfferta: 'Cond. Ofrecidas',
            leggiTutto: 'Mostrar más...',
            leggiMeno: 'Mostrar menos...',
            resa: 'Envío',
            pagamento: 'Pago',
            qtaForn: 'Cantidad Prov.',
            uMis: 'U. M.',
            ultimaOfferta: 'Ultima oferta',
            ultimoOrdine: 'Ultima orden',
            numOrdine: 'Número de orden',
            lastOfferOrder: 'Condiciones ultima Orden/Oferta',
            annulla: 'Cancelar',
            continuare: '¿Seguro que quieres continuar?',
            attenzione: 'Atención',
            errorFormatMail: 'Formato de correo no válido',
            disegniARicambio: 'Dibujo tecnico',
            nrDisegnoTes: 'Código Diseño',
            formatoDis: 'Formato',
            tipoAllegato: 'Tipo de Accesorio',
            divisa: 'Moneda',
            upload: 'Upload',
            documentiProdotto: 'Documentos del producto',
            idDocumento: 'ID del Documento',
            nomeFile: 'Nombre de Archivo',
            tipoDocumento: 'Tipo de Documento',
            dataCaricamento: 'Fecha de Carga',
            schedaSicurezza: 'Ficha de Seguridad',
            scegli: 'Elegir...',
            documentiCaricati: 'Documentos Cargados',
            rosso: 'Hoja de datos de seguridad falta/no cumple',
            giallo: 'Hoja de datos de seguridad en aprobación',
            verde: 'Hoja de datos de seguridad conforme',
            caricamentoOK: 'Documento guardado exitosamente',
            caricamentoKO: 'Error de carga',
            nonInRegola: 'Faltan una o más fichas de seguridad o las que están en nuestro poder no son conformes. Por favor revise y actualice la oferta.',
            controlloSchedeSic: 'Confirme que los registros en nuestro poder están relacionados con los productos ofrecidos?',
            verificaDocumenti: 'Por favor revise y actualice los documentos. Gracias',
            si: 'Sí',
            no: 'No',
            annullaIgnora: 'Cancelar',
            dataSheet: 'Data Sheet',
            trattativa: 'Negociación',
            ufficioAcquisti: 'Oficina de Compras',
            fornitore: 'Proveedor',
            conferma: 'Confirmación',
            storico: 'Histórico',
            prezzoRichiesto: 'Precio Requerido',
            qtaRichiesta: 'Cantidad Solicitud',
            accetta: 'Aceptar',
            rifiuta: 'Rechazar',
            uffAcq: 'Ofic. Comp.',
            storicoOfferta: 'Oferta',
            storicoSconto: 'Des',
            verificaProdRiaperti: 'Negociación no completa',
            prodotti: 'Productos',
            documentiOfferta: 'Documentos Oferta',
            documentiOffertaTitolo: 'Documentos: Oferta',
            documentiProdottoTitolo: 'Documentos: Producto',
            valPrecedente: 'Valor anterior',
            valida: 'Aceptar'
          }
        },
        de_DE: {
          dettaglioOfferta: {
            offerta: 'Angebot',
            del: 'vom',
            validaFino: 'Gültig bis',
            prodotto: 'Produkt',
            qta: 'Menge',
            descrizione: 'Beschreibung',
            email: 'E-Mail',
            trasporto: 'Transport',
            imballo: 'Verpackung',
            prezzo: 'Preis',
            posizione: 'Pos.',
            prodRif: 'Produktref.',
            prezzoUnitario: 'Stückpreis',
            vsOfferta: 'Ihr Angebot',
            riporta: 'Bericht',
            titoloLastOffer: 'Letzte Angebotsbedingungen oder letzte Bestellung',
            ok: 'Ok',
            cancella: 'Löschen',
            titoloCheckConsegna: 'Angebotsanfragen',
            salva: 'Speichern',
            salvaInvia: 'Speichern und Senden',
            elimina: 'Löschen',
            erroreParametro: 'Falsche oder fehlende Daten',
            erroreParametroDettaglio: 'Fehler',
            pagina: 'seite',
            rifCof: 'Ihre Referenz',
            przUni: 'Preis',
            datRifCof: 'Datum Ihre Referenz',
            notaTes: 'Geprüfte Notiz',
            indEmail: 'E-Mail',
            costTrasp: 'Transportkosten',
            costImbal: 'Kosten für die Verpackung',
            numGgCons: 'Anzahl der Tage Lieferung von der Bestellung',
            datCons: 'Lieferdatum',
            scPerc1: 'Rabatt 1',
            scPerc2: 'Rabatt 2',
            erroreDataNumGg: 'Geben Sie entweder ein Lieferdatum oder Tage ab der Bestellung ein',
            titoloCheckSizeError: 'Zwischenspeichern',
            msgErrorSizeModified: 'Bitte speichern Sie die bisherigen Eingaben, bevor Sie fortfahren.',
            noteFornitore: 'Hinweise für den Lieferanten',
            consegna: 'Lieferung',
            numSettCons: 'in Wochen ab Bestelleingang',
            note: 'Anmerkung',
            condOfferta: 'Angebotsbeding.',
            leggiTutto: 'Zeige mehr...',
            leggiMeno: 'Zeige weniger...',
            resa: 'Lieferung',
            pagamento: 'Zahlung',
            qtaForn: 'Menge Lief.',
            uMis: 'Maßeinheit',
            ultimaOfferta: 'Letztes Angebot',
            ultimoOrdine: 'Letzte Bestellung',
            numOrdine: 'Bestellnummer',
            lastOfferOrder: 'Bedingungen letzte Bestellung/Angebot',
            annulla: 'Stornieren',
            continuare: 'Möchten Sie wirklich fortfahren?',
            attenzione: 'Achtung',
            errorFormatMail: 'Ungültiges E-Mail-Format',
            disegniARicambio: 'Technisches Zeichnen',
            nrDisegnoTes: 'Konstruktionscode',
            formatoDis: 'Format',
            tipoAllegato: 'Art des Anhangs',
            divisa: 'Währung',
            upload: 'Upload',
            documentiProdotto: 'Produktdokumente',
            idDocumento: 'Dokument-ID',
            nomeFile: 'Dateiname',
            tipoDocumento: 'Dokumenttyp',
            dataCaricamento: 'Ladedatum',
            schedaSicurezza: 'Sicherheitsdatenblatt',
            scegli: 'Wählen...',
            documentiCaricati: 'Hochgeladene Dokumente',
            rosso: 'Sicherheitsdatenblatt fehlt/nicht konform',
            giallo: 'Sicherheitsdatenblatt in Zulassung',
            verde: 'Konformes Sicherheitsdatenblatt',
            caricamentoOK: 'Dokument erfolgreich gespeichert',
            caricamentoKO: 'Uploadfehler',
            nonInRegola: 'Ein oder mehrere Sicherheitsdatenblätter fehlen oder sind in unserem. Besitz aber nicht konform. Bitte überprüfen Sie und aktualisieren Sie das Angebot',
            controlloSchedeSic: 'Bestätigen Sie, dass sich die Aufzeichnungen in unserem Besitz auf die angebotenen Produkte beziehen?',
            verificaDocumenti: 'Bitte überprüfen und aktualisieren Sie die Dokumente. Danke',
            si: 'Ja',
            no: 'Nein',
            annullaIgnora: 'Ignorieren',
            dataSheet: 'Data Sheet',
            trattativa: 'Verhandlung',
            ufficioAcquisti: 'Einkaufsbüro',
            fornitore: 'Lieferant',
            conferma: 'Bestätigung',
            storico: 'Historisch',
            prezzoRichiesto: 'Preis Erforderlich',
            qtaRichiesta: 'Menge Erforderlich',
            accetta: 'Akzeptieren',
            rifiuta: 'Ablehnen',
            uffAcq: 'Einkaufsbüro',
            storicoOfferta: 'Angebot',
            storicoSconto: 'Rab',
            verificaProdRiaperti: 'Verhandlung nicht abgeschlossen',
            prodotti: 'Produkte',
            documentiOfferta: 'Angebotsunterlagen',
            documentiOffertaTitolo: 'Dokumente: Angebot',
            documentiProdottoTitolo: 'Dokumente: Produkt',
            valPrecedente: 'Vorheriger Wert',
            valida: 'Akzeptieren'
          }
        },
        en_GB: {
          dettaglioOfferta: {
            offerta: 'Offer',
            del: 'of',
            validaFino: 'Valid untill',
            prodotto: 'Product',
            qta: 'Qty',
            descrizione: 'Description',
            email: 'eMail',
            trasporto: 'Transport',
            imballo: 'Packing',
            prezzo: 'Price',
            posizione: 'Position',
            prodRif: 'Prod. Ref.',
            prezzoUnitario: 'Unit Price',
            vsOfferta: 'Your Offer',
            riporta: 'Reports',
            titoloLastOffer: 'Last offer or last order conditions',
            ok: 'Ok',
            cancella: 'Back',
            titoloCheckConsegna: 'Offer Request',
            salva: 'Save',
            salvaInvia: 'Save and Send',
            elimina: 'Delete',
            erroreParametro: 'Wrong or missing data',
            erroreParametroDettaglio: 'Error',
            pagina: 'page',
            rifCof: 'Your Reference',
            przUni: 'Price',
            datRifCof: 'Date of Your Reference',
            notaTes: 'Tested note',
            indEmail: 'E-mail',
            costTrasp: 'Transportation Cost',
            costImbal: 'Cost of Packaging',
            numGgCons: 'Number of days delivery from the order',
            datCons: 'Date of Delivery',
            scPerc1: 'Discount 1',
            scPerc2: 'Discount 2',
            erroreDataNumGg: 'Enter either a delivery date or days from the order',
            titoloCheckSizeError: 'Partial Saving',
            msgErrorSizeModified: 'The maximum limit of 50 modified lines has been reached, before proceeding with the others save the current changes.',
            noteFornitore: 'Notes for the Supplier',
            consegna: 'Delivery',
            numSettCons: 'Weeks from order',
            note: 'Notes',
            condOfferta: 'Cond. Offerta',
            leggiTutto: 'Show more...',
            leggiMeno: 'Show less...',
            resa: 'Return',
            pagamento: 'Payment',
            qtaForn: 'Qty Supp.',
            uMis: 'U. Meas.',
            ultimaOfferta: 'Last Offer',
            ultimoOrdine: 'Last Order',
            numOrdine: 'Order Number',
            lastOfferOrder: 'Last Order/Offer conditions',
            annulla: 'Cancel',
            continuare: 'Are you sure you want to continue?',
            attenzione: 'Attention',
            errorFormatMail: 'Invalid mail format',
            disegniARicambio: 'Technical design',
            nrDisegnoTes: 'Design Code',
            formatoDis: 'Format',
            tipoAllegato: 'Attachment Type',
            divisa: 'Currency',
            upload: 'Upload',
            documentiProdotto: 'Product documents',
            idDocumento: 'Document ID',
            nomeFile: 'File Name',
            tipoDocumento: 'Document Type',
            dataCaricamento: 'Upload Date',
            schedaSicurezza: 'Safety Datasheet',
            scegli: 'Choose...',
            documentiCaricati: 'Uploaded Documents',
            rosso: 'Safety Data Sheet Missing/Non-Compliant',
            giallo: 'Safety Data Sheet in Approval',
            verde: 'Compliant Safety Data Sheet',
            caricamentoOK: 'Document saved successfully',
            caricamentoKO: 'Upload error',
            nonInRegola: 'One or more safety data sheets in our possession are missing or do not compliant. Please check and update the offer',
            controlloSchedeSic: 'Could you please confirm that the safety data sheets in our possession are related to the products offered?',
            verificaDocumenti: 'Please check and update the documents. Thank you',
            si: 'Yes',
            no: 'No',
            annullaIgnora: 'Cancel',
            dataSheet: 'Data Sheet',
            trattativa: 'Dealing',
            ufficioAcquisti: 'Purchasing Office',
            fornitore: 'Supplier',
            conferma: 'Confirmation',
            storico: 'Historical',
            prezzoRichiesto: 'Required Price',
            qtaRichiesta: 'Qty Required',
            accetta: 'Accept',
            rifiuta: 'Reject',
            uffAcq: 'Purch. Off.',
            storicoOfferta: 'Offer',
            storicoSconto: 'Disc',
            verificaProdRiaperti: 'Dealing not completed',
            prodotti: 'Products',
            documentiOfferta: 'Offer Documents',
            documentiOffertaTitolo: 'Documents: Offer',
            documentiProdottoTitolo: 'Documents: Product',
            valPrecedente: 'Previous value',
            valida: 'Accept'
          }
        }
      }
    },
    data () {
      return {
        codLang: sessionStorage.getItem('codLang'),
        form: {},
        offerta: {},
        currentPage: 1,
        currentPagePaginator: 1,
        pag_for: 7,
        testata: {},
        rese: [],
        uMis: {},
        prodotti: [],
        nrPages: 0,
        nrItems: 0,
        desProdEst: '',
        loading: false,
        formProdotto: {},
        prodottiModificati: {},
        condizioniOfferta: [],
        showLastOffer: false,
        lastOfferProdotto: {},
        codPosConsegna: 0,
        changedCounter: 0,
        showCheckSizeError: false,
        pagineModificate: [],
        disabled: false,
        showDesEstesaFull: false,
        valSettCons: '',
        saveDisabled: false,
        showContinua: false,
        disegni: [],
        disegniCodProd: '',
        disegniDescProd: '',
        showDisegniModal: false,
        divise: [],
        divisa: '',
        prodottoSelectedDoc: {},
        ifDocumentiVisible: false,
        uploadList: [],
        tipiDoc: [],
        tipoDocSelected: '',
        documenti: [],
        moment: moment,
        loadingDoc: false,
        showTrattativa: false,
        prodTrattativa: {},
        storico: [],
        loadingStorico: false,
        counterConfermati: 0,
        tipiDocOfferta: [],
        tipoDocOffertaSelected: '',
        documentiOfferta: [],
        ifDocumentiOffertaVisible: false,
        uploadListOfferta: []
      }
    },
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
      })
    },
    activated: function () {
      this.init()
    },
    deactivated: function () {
      this.resetDati()
    },
    watch: {
      valSettCons: function (newVal, oldVal) {
        let _this = this
        Object.keys(this.formProdotto).forEach(function(key) {
          if (_this.formProdotto[key].edit !== true) {
            _this.formProdotto[key].numSettCons = newVal
          }
        })
      }
    },
    methods: {
      openSchedeSicKO: function () {
        this.$confirm(this.$t('dettaglioOfferta.verificaDocumenti'), this.$t('dettaglioOfferta.attenzione').toUpperCase(), {
          confirmButtonText: this.$t('dettaglioOfferta.ok').toUpperCase(),
          type: 'warning',
          customClass: 'custom-confirm',
          showClose: false,
          showCancelButton: false,
          closeOnClickModal: false
        }).then(() => {
          this.$set(this, 'showContinua', false)
        }).catch(() => {
          //
        })
      },
      handleRemove: function (file, fileList) {
        this.$set(this, 'uploadList', fileList)
      },
      handleRemoveOfferta: function (file, fileList) {
        this.$set(this, 'uploadListOfferta', fileList)
      },
      handleExceed: function () {
        this.$message({
          showClose: true,
          message: 'Permesso solo l\'upload di un file alla volta',
          type: 'error',
          duration: process.env.duration
        })
      },
      changeUploadList: function (file, fileList) {
        this.$set(this, 'uploadList', fileList)
      },
      changeUploadListOfferta: function (file, fileList) {
        this.$set(this, 'uploadListOfferta', fileList)
      },
      goToDocumenti: function (prod) {
        this.$set(this, 'prodottoSelectedDoc', prod)
        this.getTipiDoc(prod)
      },
      goToDocumentiOfferta: function () {
        this.getTipiDocOfferta()
      },
      getTipiDoc: function (prod) {
        this.$set(this, 'tipiDoc', [])
        this.$set(this, 'tipoDocSelected', '')
        this.$http.get('richiestediofferta/tipidoc', {
          params: {
            country: this.form.country,
            codLang: this.codLang,
            codProd: prod.codProd
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'tipiDoc', response.body.data)
              this.$set(this, 'tipoDocSelected', response.body.data[0].codTipoDoc)
            } else {
              /*
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              */
            }
            this.getDocumenti(prod.codProd)
          })
      },
      getTipiDocOfferta: function () {
        this.$set(this, 'tipiDocOfferta', [])
        this.$set(this, 'tipoDocOffertaSelected', '')
        this.$http.get('richiestediofferta/tipidoctestata', {
          params: {
            country: this.form.country,
            codLang: this.codLang,
            numRif: this.offerta.numRif
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'tipiDocOfferta', response.body.data)
              this.$set(this, 'tipoDocOffertaSelected', response.body.data[0].codTipoDoc)
            } else {
              /*
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              */
            }
            this.getDocumentiOfferta()
          })
      },
      getDocumenti: function (codProd) {
        this.$set(this, 'loadingDoc', true)
        this.$http.get('richiestediofferta/listdoc', {
          params: {
            country: this.form.country,
            codLang: this.codLang,
            codForn: this.form.codForn,
            codProd: codProd
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'documenti', response.body.data)
            } else {
              /*
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              */
              this.$set(this, 'documenti', [])
            }
            this.$set(this, 'loadingDoc', false)
            this.$set(this, 'ifDocumentiVisible', true)
          })
      },
      getDocumentiOfferta: function () {
        this.$set(this, 'loadingDoc', true)
        this.$http.get('richiestediofferta/listdoctestata', {
          params: {
            country: this.form.country,
            codLang: this.codLang,
            codForn: this.form.codForn,
            numRif: this.offerta.numRif
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'documentiOfferta', response.body.data)
            } else {
              /*
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              */
              this.$set(this, 'documentiOfferta', [])
            }
            this.$set(this, 'loadingDoc', false)
            this.$set(this, 'ifDocumentiOffertaVisible', true)
          })
      },
      getDoc: function (documento) {
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              let url = (process.env.baseUrlSpringAcquisti + 'print/documento' +
                '?keyDoc=' + documento.keyDoc +
                '&idCli=' + documento.idCli + '&idApp=' + documento.idApp +
                '&token=' + response.body.wsToken
              )
              let win = window.open(url, '_blank')
              win.focus()
            } else {
              this.$message({
                showClose: true,
                message: 'Error creating token',
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      deleteDoc: function (documento) {
        this.$set(this, 'loadingDoc', true)
        let data = {
          codLang: this.codLang,
          country: this.form.country,
          codForn: this.form.codForn,
          codProd: this.prodottoSelectedDoc.codProd,
          keyDoc: documento.keyDoc,
          progressivo: documento.progressivo,
          dataDoc: documento.dataDoc,
          idCli: documento.idCli,
          idApp: documento.idApp,
          numRif: this.offerta.numRif
        }
        this.$http.delete('richiestediofferta/deldoc', {
          body: data
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'success',
                duration: process.env.duration
              })
            } else {
               this.$message({
               showClose: true,
               message: response.body.msg[0].msgTxt,
               type: 'error',
               duration: process.env.duration
               })
            }
            this.getDocumenti(this.prodottoSelectedDoc.codProd)
          })
      },
      deleteDocOfferta: function (documento) {
        this.$set(this, 'loadingDoc', true)
        let data = {
          codLang: this.codLang,
          country: this.form.country,
          codForn: this.form.codForn,
          keyDoc: documento.keyDoc,
          progressivo: documento.progressivo,
          dataDoc: documento.dataDoc,
          numRif: this.offerta.numRif
        }
        this.$http.delete('richiestediofferta/deldoctestata', {
          body: data
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'success',
                duration: process.env.duration
              })
            } else {
               this.$message({
               showClose: true,
               message: response.body.msg[0].msgTxt,
               type: 'error',
               duration: process.env.duration
               })
            }
            this.getDocumentiOfferta()
          })
      },
      uploadDoc: function () {
        if (this.tipoDocSelected === 'FORSCHSIC') {
          this.$set(this, 'loadingDoc', true)

          let formData = new FormData()
          formData.append('codLang', this.codLang)
          formData.append('country', this.form.country)
          formData.append('codForn', this.form.codForn)
          formData.append('codProd', this.prodottoSelectedDoc.codProd)
          formData.append('numRif', this.offerta.numRif)
          formData.append('file', this.uploadList[0].raw)

          this.$http.post('richiestediofferta/schedasic', formData)
            .then(response => {
              if (response.body.rc === 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('dettaglioOfferta.caricamentoOK'),
                  type: 'success',
                  duration: process.env.duration
                })
                this.getDocumenti(this.prodottoSelectedDoc.codProd)
              } else {
                this.$message({
                  showClose: true,
                  message: this.$t('dettaglioOfferta.caricamentoKO'),
                  type: 'error',
                  duration: process.env.duration
                })
                this.$set(this, 'loadingDoc', false)
              }
              this.$set(this, 'uploadList', [])
              this.$refs.uploadDoc.clearFiles()
            })
        } else if (this.tipoDocSelected === 'FORDATSHE') {
          this.$set(this, 'loadingDoc', true)

          let formData = new FormData()
          formData.append('codLang', this.codLang)
          formData.append('country', this.form.country)
          formData.append('codForn', this.form.codForn)
          formData.append('codProd', this.prodottoSelectedDoc.codProd)
          formData.append('numRif', this.offerta.numRif)
          formData.append('file', this.uploadList[0].raw)

          this.$http.post('richiestediofferta/datasheet', formData)
            .then(response => {
              if (response.body.rc === 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('dettaglioOfferta.caricamentoOK'),
                  type: 'success',
                  duration: process.env.duration
                })
                this.getDocumenti(this.prodottoSelectedDoc.codProd)
              } else {
                this.$message({
                  showClose: true,
                  message: this.$t('dettaglioOfferta.caricamentoKO'),
                  type: 'error',
                  duration: process.env.duration
                })
                this.$set(this, 'loadingDoc', false)
              }
              this.$set(this, 'uploadList', [])
              this.$refs.uploadDoc.clearFiles()
            })
        }
      },
      uploadDocOfferta: function () {
        this.$set(this, 'loadingDoc', true)

        let formData = new FormData()
        formData.append('codLang', this.codLang)
        formData.append('country', this.form.country)
        formData.append('codForn', this.form.codForn)
        formData.append('codTipoDoc', this.tipoDocOffertaSelected)
        formData.append('numRif', this.offerta.numRif)
        formData.append('file', this.uploadListOfferta[0].raw)

        this.$http.post('richiestediofferta/doctestata', formData)
          .then(response => {
            if (response.body.rc === 0) {
              this.$message({
                showClose: true,
                message: this.$t('dettaglioOfferta.caricamentoOK'),
                type: 'success',
                duration: process.env.duration
              })
              this.getDocumentiOfferta()
            } else {
              this.$message({
                showClose: true,
                message: this.$t('dettaglioOfferta.caricamentoKO'),
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this, 'loadingDoc', false)
            }
            this.$set(this, 'uploadListOfferta', [])
            this.$refs.uploadDocOfferta.clearFiles()
          })
      },
      closeDocumenti: function () {
        this.$set(this, 'uploadList', [])
        this.$set(this, 'tipoDocSelected', '')
        this.$refs.uploadDoc.clearFiles()
        this.loadOfferta(true)
      },
      closeDocumentiOfferta: function () {
        this.$set(this, 'uploadListOfferta', [])
        this.$set(this, 'tipoDocOffertaSelected', '')
        this.$refs.uploadDocOfferta.clearFiles()
      },
      returnUMisKey: function (row) {
        return (row.codUMis + '-' + row.codUMisConv)
      },
      changeDivisa: function (newDivisa) {
        this.divise.forEach((divisa) => {
          if (divisa.codDivisa === newDivisa) {
            this.$set(this, 'divisa', divisa.desDivisa)
          }
        })
      },
      getDisegno: function (doc) {
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              let url = (process.env.baseUrlSpringAcquisti + 'print/offerte/disegno' +
                '?keyDoc=' + doc.keyDoc +
                '&token=' + response.body.wsToken
              )
              let win = window.open(url, '_blank')
              win.focus()
            } else {
              this.$message({
                showClose: true,
                message: 'Error creating token',
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      openDisegniModal: function (riga) {
        this.$set(this, 'disegni', riga.fabDis)
        this.$set(this, 'disegniCodProd', riga.codProd)
        this.$set(this, 'disegniDescProd', riga.desProd + ' (' + riga.numQta + ' ' + riga.codUMis + ')')
        this.$set(this, 'showDisegniModal', true)
      },
      resetDati: function () {
        this.$set(this, 'saveDisabled', false)
        this.$set(this, 'form', {})
        this.$set(this, 'offerta', {})
        this.$set(this, 'currentPage', 1)
        this.$set(this, 'currentPagePaginator', 1)
        this.$set(this, 'testata', {})
        this.$set(this, 'rese', [])
        this.$set(this, 'uMis', {})
        this.$set(this, 'prodotti', [])
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'nrItems', 0)
        this.$set(this, 'desProdEst', '')
        this.$set(this, 'loading', false)
        this.$set(this, 'formProdotto', {})
        this.$set(this, 'prodottiModificati', {})
        this.$set(this, 'condizioniOfferta', [])
        this.$set(this, 'showLastOffer', false)
        this.$set(this, 'lastOfferProdotto', {})
        this.$set(this, 'codPosConsegna', 0)
        this.$set(this, 'changedCounter', 0)
        this.$set(this, 'showCheckSizeError', false)
        this.$set(this, 'pagineModificate', [])
        this.$set(this, 'disabled', false)
        this.$set(this, 'showDesEstesaFull', false)
        this.$set(this, 'showContinua', false)
        this.$set(this, 'valSettCons', '')
        this.$set(this, 'disegni', [])
        this.$set(this, 'showDisegniModal', false)
        this.$set(this, 'disegniCodProd', '')
        this.$set(this, 'disegniDescProd', '')
        this.$set(this, 'divise', [])
        this.$set(this, 'prodottoSelectedDoc', {})
        this.$set(this, 'ifDocumentiVisible', false)
        this.$set(this, 'uploadList', [])
        this.$set(this, 'tipiDoc', [])
        this.$set(this, 'tipoDocSelected', '')
        this.$set(this, 'documenti', [])
        this.$set(this, 'loadingDoc', false)
        this.$set(this, 'showTrattativa', false)
        this.$set(this, 'prodTrattativa', {})
        this.$set(this, 'storico', [])
        this.$set(this, 'loadingStorico', false)
        this.$set(this, 'counterConfermati', 0)
        this.$set(this, 'tipiDocOfferta', [])
        this.$set(this, 'tipoDocOffertaSelected', '')
        this.$set(this, 'documentiOfferta', [])
        this.$set(this, 'ifDocumentiOffertaVisible', false)
        this.$set(this, 'uploadListOfferta', [])
      },
      init: function () {
        if (sessionStorage.hasOwnProperty('RdO_offerta') && sessionStorage.hasOwnProperty('RdO_form')) {
          this.$set(this, 'offerta', JSON.parse(sessionStorage.getItem('RdO_offerta')))
          this.$set(this, 'form', JSON.parse(sessionStorage.getItem('RdO_form')))
          this.getDivise()
          this.getConOfferta()
          this.getUMis()
          this.getRese()
          this.$emit('showScroll')
          this.loadOfferta(false)
          if (this.offerta.codAvanz === 'I') {
            this.$set(this, 'disabled', true)
          }
        } else {
          this.$router.push({name: 'RdOOfferte'})
        }
      },
      changeShowDesEstesaFull: function () {
        this.showDesEstesaFull = !this.showDesEstesaFull
      },
      riportaOfferta: function () {
        this.formProdotto[this.lastOfferProdotto.codPos].edit = true
        this.formProdotto[this.lastOfferProdotto.codPos].przUniT_2 = this.lastOfferProdotto.przUniLO
        this.formProdotto[this.lastOfferProdotto.codPos].scPerc1T_2 = this.lastOfferProdotto.scPerc1LO
        this.formProdotto[this.lastOfferProdotto.codPos].scPerc2T_2 = this.lastOfferProdotto.scPerc2LO
        this.formProdotto[this.lastOfferProdotto.codPos].codProdRif = this.lastOfferProdotto.codProdRif
        this.showLastOffer = false
      },
      riportaOrdine: function () {
        this.formProdotto[this.lastOfferProdotto.codPos].edit = true
        this.formProdotto[this.lastOfferProdotto.codPos].przUniT_2 = this.lastOfferProdotto.przUniLOrd
        this.formProdotto[this.lastOfferProdotto.codPos].scPerc1T_2 = this.lastOfferProdotto.scPerc1LOrd
        this.formProdotto[this.lastOfferProdotto.codPos].scPerc2T_2 = this.lastOfferProdotto.scPerc2LOrd
        this.formProdotto[this.lastOfferProdotto.codPos].codProdRif = this.lastOfferProdotto.codProdRif
        this.showLastOffer = false
      },
      goToLastOffer: function (prodotto) {
        if (this.changedCounter > 50 && this.formProdotto[prodotto.codPos].edit !== true) {
          this.showCheckSizeError = true
        } else {
          this.$set(this, 'lastOfferProdotto', prodotto)
          this.showLastOffer = true
        }
      },
      selectProdotto: function (row, event, column) {
        this.$refs.carousel.setActiveItem(this.prodotti.indexOf(row))
      },
      changeRowPrz: function (rowID) {
        let prz = this.formProdotto[rowID].przUniT_2.toString()
        let array = prz.split(new RegExp(/[.,]/))
        if (array.length > 1) {
          let decimal = array.pop()
          prz = array.join('') + '.' + decimal
          this.formProdotto[rowID].przUniT_2 = prz
        }
        this.changeRow(rowID)
      },
      changeRow: function (rowID, ifChangeNumSettCons) {
        if (ifChangeNumSettCons === true) {
          this.valSettCons = this.formProdotto[rowID].numSettCons
        }
        if (this.formProdotto[rowID].ifRiaperto === '1' && !this.formProdotto[rowID].edit) {
          this.counterConfermati++
        }
        this.formProdotto[rowID].edit = true
        this.formProdotto[rowID].saved = false
      },
      changeSlide: function (newIndex, oldIndex) {
        this.loadDesProdEstesa(this.prodotti[newIndex].codProd)
      },
      changePage: function (page) {
        this.formProdottoFiltered()
        this.currentPage = page
        this.loadOfferta(false)
      },
      focusCheck: function (codPos) {
        if (this.changedCounter > 50 && this.formProdotto[codPos].edit !== true) {
          this.showCheckSizeError = true
        }
      },
      closeCheckSizeError: function (flag) {
        if (flag === true) {
          this.salva('S', false)
          this.loadOfferta()
        }
        this.showCheckSizeError = false
      },
      convalida: function (rowID) {
        if (this.formProdotto[rowID].ifRiaperto === '1' && !this.formProdotto[rowID].edit) {
          this.counterConfermati++
        }
        this.formProdotto[rowID].edit = true
        this.formProdotto[rowID].saved = false
      },
      loadOfferta: function (ifCloseDocumenti) {
        this.$http.get('richiestediofferta/offerta', {
          params: {
            country: this.form.country,
            codLang: this.codLang,
            codForn: this.form.codForn,
            numRif: this.offerta.numRif,
            pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
            pag_from: ((this.currentPage - 1) * this.pag_for) + 1,
            pag_for: this.pag_for
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              if (JSON.stringify(this.testata) === '{}') {
                this.$set(this, 'testata', response.body.attrib)
                this.changeDivisa(response.body.attrib.divisa)
              }

              response.body.data.forEach((item) => {
                if (this.formProdotto[item.codPos] === undefined) {
                  this.$set(this.formProdotto, item.codPos, item)

                  if (!item.codUMisForn) {
                    this.$set(this.formProdotto[item.codPos], 'codUMisForn', item.codUMis)
                  }

                  let _this = this
                  Object.keys(this.formProdotto).forEach(function(key) {
                    if (!_this.formProdotto[key].edit && _this.formProdotto[key].numSettCons === '') {
                      this.$set(_this.formProdotto[key], 'numSettCons', _this.valSettCons)
                    }
                  })

                  this.$set(this.formProdotto[item.codPos], 'edit', false)
                  if ((item.przUni && item.numSettCons) || item.codConOff === 'PO') {
                    this.$set(this.formProdotto[item.codPos], 'saved', true)
                  }

                  // Campi trattativa PRODOTTO
                  if (item.przUniT && item.przUni !== item.przUniT) {
                    this.$set(this.formProdotto[item.codPos], 'przUniT_2', item.przUniT)
                  } else {
                    this.$set(this.formProdotto[item.codPos], 'przUniT_2', item.przUni)
                  }
                  if (item.scPerc1T && item.scPerc1 !== item.scPerc1T) {
                    this.$set(this.formProdotto[item.codPos], 'scPerc1T_2', item.scPerc1T)
                  } else {
                    this.$set(this.formProdotto[item.codPos], 'scPerc1T_2', item.scPerc1)
                  }
                  if (item.scPerc2T && item.scPerc2 !== item.scPerc2T) {
                    this.$set(this.formProdotto[item.codPos], 'scPerc2T_2', item.scPerc2T)
                  } else {
                    this.$set(this.formProdotto[item.codPos], 'scPerc2T_2', item.scPerc2)
                  }
                  if (item.codConOffT && item.codConOff !== item.codConOffT) {
                    this.$set(this.formProdotto[item.codPos], 'codConOffT_2', item.codConOffT)
                  } else {
                    this.$set(this.formProdotto[item.codPos], 'codConOffT_2', item.codConOff)
                  }
                  if (item.qtaTrattativaT && item.qtaTrattativa !== item.qtaTrattativaT) {
                    this.$set(this.formProdotto[item.codPos], 'qtaTrattativaT_2', item.qtaTrattativaT)
                  } else {
                    this.$set(this.formProdotto[item.codPos], 'qtaTrattativaT_2', item.qtaTrattativa)
                  }
                }
              })

              // Campi trattativa TESTATA
              if (this.testata.codResaT && this.testata.codResa !== this.testata.codResaT) {
                this.$set(this.testata, 'codResaT_2', this.testata.codResaT)
              } else {
                this.$set(this.testata, 'codResaT_2', this.testata.codResa)
              }
              if (this.testata.costTraspT && this.testata.costTrasp !== this.testata.costTraspT) {
                this.$set(this.testata, 'costTraspT_2', this.testata.costTraspT)
              } else {
                this.$set(this.testata, 'costTraspT_2', this.testata.costTrasp)
              }
              if (this.testata.costImbalT && this.testata.costImbal !== this.testata.costImbalT) {
                this.$set(this.testata, 'costImbalT_2', this.testata.costImbalT)
              } else {
                this.$set(this.testata, 'costImbalT_2', this.testata.costImbal)
              }
              if (this.testata.codPagT && this.testata.codPag !== this.testata.codPagT) {
                this.$set(this.testata, 'codPagT_2', this.testata.codPagT)
                this.$set(this.testata, 'desPagT_2', this.testata.desPagT)
              } else {
                this.$set(this.testata, 'codPagT_2', this.testata.codPag)
                this.$set(this.testata, 'desPagT_2', this.testata.desPag)
              }

              if (!this.testata.indEmail) {
                this.$set(this.testata, 'indEmail', sessionStorage.getItem('mailFornitore'))
              }

              this.$set(this, 'prodotti', response.body.data)

              if (this.currentPage === 1) {
                this.$set(this, 'nrItems', parseInt(response.body.attrib.size))

                let resto = parseInt(response.body.attrib.size) % this.pag_for
                let aggiunta = (resto > 0) ? 1 : 0
                let nrPages = Math.floor(parseInt(response.body.attrib.size) / this.pag_for) + aggiunta
                this.$set(this, 'nrPages', nrPages)
              }

              if (ifCloseDocumenti !== true) {
                this.loadDesProdEstesa(this.prodotti[0].codProd)
                this.$refs.carousel.setActiveItem(0)
              } else {
                let index = (parseInt(this.prodottoSelectedDoc.codPos) - 1) % this.pag_for

                this.loadDesProdEstesa(this.prodotti[index].codProd)
                this.$refs.carousel.setActiveItem(index)
              }

            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      loadDesProdEstesa: function (codProd) {
        this.loading = true
        this.$set(this, 'desProdEst', '')
        this.$http.get('richiestediofferta/descprodestesa', {
          params: {
            country: this.form.country,
            codLang: this.codLang,
            codProd: codProd
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.desProdEst = response.body.data[0].desProdEst
              this.loading = false
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      getConOfferta: function () {
        this.$http.get('richiestediofferta/condizioniofferta', {
          params: {
            country: this.form.country,
            codLang: this.codLang
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.condizioniOfferta = response.body.data
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      getDivise: function () {
        this.$http.get('richiestediofferta/divise', {
          params: {
            country: this.form.country,
            codLang: this.codLang
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'divise', response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      getRese: function () {
        this.$http.get('richiestediofferta/rese', {
          params: {
            country: this.form.country,
            codLang: this.codLang
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.rese = response.body.data
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      getUMis: function () {
        this.$http.get('richiestediofferta/unitamisura', {
          params: {
            country: this.form.country,
            codLang: this.codLang
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              // this.uMis = response.body.data
              let data = response.body.data
              data.forEach(obj => {
                if (this.uMis[obj.codUMis] === undefined) {
                  let array = []
                  data.forEach(row => {
                    if (row.codUMis === obj.codUMis) {
                      array.push(row)
                    }
                  })
                  this.$set(this.uMis, obj.codUMis, array)
                }
              })
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      formProdottoFiltered: function () {
        let products = {}
        for (let key in this.formProdotto) {
          if (this.formProdotto[key].edit) {
            products[key] = this.formProdotto[key]
          }
        }
        this.$set(this, 'prodottiModificati', products)
        this.changedCounter = Object.keys(products).length
      },
      openIfSalvaInvia: function () {
        if (this.validateEmail(this.testata.indEmail)) {
          if (this.counterConfermati !== parseInt(this.testata.numProdRiaperti)) {
            this.$confirm(
              this.$t('dettaglioOfferta.verificaProdRiaperti')
                  + ' (' + this.counterConfermati + '/' + this.testata.numProdRiaperti + ' '
                  + this.$t('dettaglioOfferta.prodotti') + ')',
              this.$t('dettaglioOfferta.attenzione').toUpperCase(),
              {
                confirmButtonText: this.$t('dettaglioOfferta.ok').toUpperCase(),
                type: 'warning',
                customClass: 'custom-confirm',
                showClose: false,
                showCancelButton: false,
                closeOnClickModal: false
              }
            ).then(() => {
              //
            }).catch(() => {
              //
            })
            return
          }

          this.$set(this, 'saveDisabled', true)
          this.formProdottoFiltered()
          let array = []
          for (let key in this.prodottiModificati) {
            let item = this.prodottiModificati[key]
            let obj = {
              codPos: item.codPos,
              codProd: item.codProd,
              codConOff: (item.codConOffT_2) ? item.codConOffT_2 : ''
            }
            array.push(obj)
          }
          let dataReq = {
            country: this.form.country,
            codLang: this.codLang,
            codForn: this.form.codForn,
            numRif: this.offerta.numRif,
            data: array
          }
          this.$http.post('richiestediofferta/flagofferta', dataReq)
            .then(response => {
              if (response.body.rc === 0) {
                this.$set(this.testata, 'ifSalvaInvia', response.body.data.ifSalvaInvia)
                this.$set(this.testata, 'ifDocObblig', response.body.data.ifDocObblig)
                this.$set(this, 'showContinua', true)
              } else {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
              this.$set(this, 'saveDisabled', false)
            })
        } else {
          this.$message({
            showClose: true,
            message: this.$t('dettaglioOfferta.errorFormatMail'),
            type: 'error',
            duration: process.env.duration
          })
        }
      },
      validateEmail: function (email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email.toLowerCase())
      },
      salva: function (type, ifReturnOfferte) {
        this.$set(this, 'saveDisabled', true)
        this.formProdottoFiltered()
        let arrayModificati = []
        for (let key in this.prodottiModificati) {
          let obj = JSON.parse(JSON.stringify(this.prodottiModificati[key]))
          delete obj['datRifCofLO']
          delete obj['desProd']
          delete obj['edit']
          delete obj['saved']
          delete obj['notaFT']
          delete obj['rifCofLO']
          delete obj['scPerc1LO']
          delete obj['scPerc2LO']
          delete obj['przUniLO']
          delete obj['numGgCons']
          delete obj['datCons']
          delete obj['desUMisForn']
          delete obj['numOrdLOrd']
          delete obj['datOrdLOrd']
          delete obj['przUniLOrd']
          delete obj['scPerc1LOrd']
          delete obj['scPerc2LOrd']
          delete obj['fabDis']
          delete obj['statoSchedSic']
          delete obj['ifRiaperto']

          if (obj.przUniT && obj.przUniT !== obj.przUni) {
            // obj.przUni = obj.przUniT_2
          }
          obj.przUni = obj.przUniT_2
          delete obj['przUniT']
          delete obj['przUniT_2']
          if (obj.scPerc1T && obj.scPerc1T !== obj.scPerc1) {
            // obj.scPerc1 = obj.scPerc1T_2
          }
          obj.scPerc1 = obj.scPerc1T_2
          delete obj['scPerc1T']
          delete obj['scPerc1T_2']
          if (obj.scPerc2T && obj.scPerc2T !== obj.scPerc2) {
            // obj.scPerc2 = obj.scPerc2T_2
          }
          obj.scPerc2 = obj.scPerc2T_2
          delete obj['scPerc2T']
          delete obj['scPerc2T_2']
          if (obj.codConOffT && obj.codConOffT !== obj.codConOff) {
            // obj.codConOff = obj.codConOffT_2
          }
          obj.codConOff = obj.codConOffT_2
          delete obj['codConOffT']
          delete obj['codConOffT_2']

          if (obj.qtaTrattativaT && (!obj.qtaTrattativa || (obj.qtaTrattativa === obj.qtaTrattativaT))) {
            obj.qtaTrattativa = obj.qtaTrattativaT_2
          } else if (obj.qtaTrattativaT && (obj.qtaTrattativa && (obj.qtaTrattativa !== obj.qtaTrattativaT))) {
            obj.qtaTrattativa = obj.qtaTrattativaT_2
          }
          delete obj['qtaTrattativaT']
          delete obj['qtaTrattativaT_2']

          if (obj.scPerc1 === '') {
            obj.scPerc1 = '0'
          }
          if (obj.scPerc2 === '') {
            obj.scPerc2 = '0'
          }
          obj.numSettCons = (obj.numSettCons !== undefined) ? obj.numSettCons.trim() : ''
          obj.przUni = (obj.przUni !== undefined) ? obj.przUni.trim() : ''
          obj.scPerc1 = (obj.scPerc1 !== undefined) ? obj.scPerc1.trim() : ''
          obj.scPerc2 = (obj.scPerc2 !== undefined) ? obj.scPerc2.trim() : ''
          obj.numQta = (obj.numQta !== undefined) ? obj.numQta.trim() : ''
          obj.qtaForn = (obj.qtaForn !== undefined) ? obj.qtaForn.trim() : ''
          arrayModificati.push(obj)
        }

        // Dati testata trattativa
        // this.$set(this.testata, 'codResa', this.testata.codResaT_2)
        let test = {
          codResa: this.testata.codResaT_2,
          costTrasp: this.testata.costTraspT_2,
          costImbal: this.testata.costImbalT_2,
          codPag: this.testata.codPagT_2
        }
        if (this.testata.codResaT && this.testata.codResaT !== this.testata.codResa) {
          // this.$set(this.testata, 'codResa', this.testata.codResaT_2)
        }
        if (this.testata.costTraspT && this.testata.costTraspT !== this.testata.costTrasp) {
          // this.$set(this.testata, 'costTrasp', this.testata.costTraspT_2)
        }
        if (this.testata.costImbalT && this.testata.costImbalT !== this.testata.costImbal) {
          // this.$set(this.testata, 'costImbal', this.testata.costImbalT_2)
        }
        if (this.testata.codPagT && this.testata.codPagT !== this.testata.codPag) {
          // this.$set(this.testata, 'codPag', this.testata.codPagT_2)
        }

        this.$http.post(process.env.jaxrsFornAcquisti + this.codLang + '/fornitura/offerte/' + this.form.country + '/offerta',
          {
            codForn: this.form.codForn,
            numRif: this.offerta.numRif,
            costTrasp: (type !== 'C') ? test.costTrasp : '',
            costImbal: (type !== 'C') ? test.costImbal : '',
            indEmail: (type !== 'C') ? this.testata.indEmail : '',
            notaTes: (type !== 'C') ? this.testata.notaTes : '',
            tipoSave: type,
            numRigTx: (type !== 'C') ? this.changedCounter : '',
            datValidita: (type !== 'C') ? this.testata.datValidita : '',
            datRifCof: (type !== 'C') ? this.testata.datRifCof : '',
            rifCof: (type !== 'C') ? this.testata.rifCof : '',
            codResa: (type !== 'C') ? test.codResa : '',
            codPag: (type !== 'C') ? test.codPag : '',
            pag_for: (type !== 'C') ? this.pag_for : '',
            divisa: (type !== 'C') ? this.testata.divisa : '',
            rows: (type !== 'C') ? arrayModificati : []
          }
        )
        // this.$http.post('richiestediofferta/offerta',
        //   {
        //     codStato: this.form.country,
        //     codLang: this.codLang,
        //     numRigTx: (type !== 'C') ? this.changedCounter : '',
        //     codForn: this.form.codForn,
        //     datValidita: (type !== 'C') ? this.testata.datValidita : '',
        //     tipoSave: type,
        //     notaTes: (type !== 'C') ? this.testata.notaTes : '',
        //     costImbal: (type !== 'C') ? test.costImbal : '',
        //     datRifCof: (type !== 'C') ? this.testata.datRifCof : '',
        //     numRif: this.offerta.numRif,
        //     rifCof: (type !== 'C') ? this.testata.rifCof : '',
        //     costTrasp: (type !== 'C') ? test.costTrasp : '',
        //     indEmail: (type !== 'C') ? this.testata.indEmail : '',
        //     pag_for: (type !== 'C') ? this.pag_for : '',
        //     codPag: (type !== 'C') ? test.codPag : '',
        //     codResa: (type !== 'C') ? test.codResa : '',
        //     divisa: (type !== 'C') ? this.testata.divisa : '',
        //     rows: (type !== 'C') ? arrayModificati : []
        //   }
        // )
          .then(response => {
            if (response.body.rc === 0) {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'success',
                duration: process.env.duration
              })
              this.$set(this, 'prodottiModificati', {})
              this.$set(this, 'changedCounter', 0)
              if (ifReturnOfferte === true) {
                this.$router.push({name: 'RdOOfferte'})
              } else {
                for (let key in this.formProdotto) {
                  this.formProdotto[key].edit = false
                }
                this.$set(this, 'prodottiModificati', {})
                this.$set(this, 'changedCounter', 0)
              }
            } else {
              if (response.body.msg[0].msgId === '0200') {
                this.$message({
                  showClose: true,
                  message: this.$i18n.messages[this.codLang].dettaglioOfferta.erroreParametro + ' (' + this.$i18n.messages[this.codLang].dettaglioOfferta[response.body.msg[0].msgTxt] + ')',
                  type: 'error',
                  duration: process.env.duration
                })
              } else if (response.body.msg[0].msgId === '0201') {
                let array = response.body.msg[0].msgTxt.split('-')
                this.$message({
                  showClose: true,
                  message: this.$i18n.messages[this.codLang].dettaglioOfferta.erroreParametroDettaglio +
                  ' (' + this.$i18n.messages[this.codLang].dettaglioOfferta[array[0]] + ' - ' +
                  this.$i18n.messages[this.codLang].dettaglioOfferta.posizione + ' ' + array[2] + ', ' +
                  this.$i18n.messages[this.codLang].dettaglioOfferta.pagina + ' ' + array[1] + ')',
                  type: 'error',
                  duration: process.env.duration
                })
              } else {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
            }
            this.$set(this, 'saveDisabled', false)
            this.$set(this, 'showContinua', false)
          })
      },
      getStorico: function () {
        this.$http.get('richiestediofferta/storicotrattativa', {
          params: {
            country: this.form.country,
            codLang: this.codLang,
            codForn: this.form.codForn,
            numRif: this.offerta.numRif,
            codPos: this.prodTrattativa.codPos,
            codProd: this.prodTrattativa.codProd
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'storico', response.body.data.reverse())
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this, 'storico', [])
            }
            this.$set(this, 'loadingStorico', false)
          })
      },
      goToTrattativa: function (prod) {
        this.$set(this, 'prodTrattativa', prod)
        this.$set(this, 'storico', [])
        this.$set(this, 'loadingStorico', true)
        this.$set(this, 'showTrattativa', true)
        this.getStorico()
      },
      tableRowClass: function ({row, rowIndex}) {
        if (row.ifRiaperto === '1') {
          return 'riaperto'
        }
        return ''
      },
      getStoricoHeaderClass: function ({columnIndex}) {
        if (columnIndex === 1 || columnIndex === 3) {
          return 'sfondo'
        }
        return ''
      }
    }
  }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .modal-trattativa {
    .prodotto {
      div {
        display: inline-block;
        margin-right: 30px;
        .set-font(@size: 15px, @color: @textTable, @family: 'os-semibolditalic');
      }
    }
    .storico {
      margin-top: 20px;
      .titolo {
        border-bottom: 1px solid @rossoRiva;
        .set-font(@color: @rossoRiva, @size: 16px, @family: 'os-semibolditalic');
        letter-spacing: 1px;
      }
      .el-table {
        margin-top: 5px;
        margin-bottom: 10px;
        .el-table__header {
          .cell {
            letter-spacing: 0;
          }
          .sfondo {
            padding-top: 5px;
            background-color: #f6f2ea !important;
          }
          .storico-header {
            line-height: 40px;
            padding: 0;
            .storico-header-top {
              line-height: 20px;
              display: block;
              text-align: center;
            }
            .storico-header-down {
              line-height: 20px;
              display: flex;
              div {
                line-height: 20px;
                text-align: center;
              }
            }
          }
        }
        .el-table__body {
          .sfondo {
            background-color: #f6f2ea !important;
          }
          .cell {
            height: 46px;
          }
        }
      }
    }
  }

  .modal-documenti {
    .el-dialog__body {
      .documenti-caricati-title {
        .set-font(@color: @oroRiva, @size: 15px, @family: 'os-semibold');
        margin-top: 20px;
        margin-bottom: 10px;
      }
      .el-table {
        min-height: 250px;
        margin-top: 25px;
        overflow: auto;
        .el-table__body {
          .cell-no-padding-left {
            .cell {
              padding-left: 0 !important;
            }
          }
          .cell {
            .cerchio {
              height: 9px;
              width: 9px;
              border-radius: 5px;
            }
            .verde {
              background-color: #0B7E26;
            }
            .giallo {
              background-color: #FFD506;
            }
            .rosso {
              background-color: #E51717;
            }
          }
        }
      }
      .upload {
        margin-top: 10px;
        .tipo-doc-label {
          .set-font(@color: @greenRiva, @size: 15px, @family: 'os-regular');
          display: inline-block;
          margin-right: 15px;
        }
        .custom-select-el {
          display: inline-block;
          margin-bottom: 20px;
          width: 330px;
          .el-input__inner {
            border: 0;
            border-bottom: 1px solid #ccc;
          }
        }
        .upload-demo {
          display: inline-block;
          width: 620px;
          vertical-align: middle;
          .el-upload {
            // display: inline-block;
            width: 150px;
            text-align: right;
            padding-left: 15px;
            vertical-align: middle;
            float: right;
            .el-button {
              width: 150px;
            }
          }
          .el-upload-list__item:first-child {
            margin-top: 0;
          }
          .el-upload-list {
            width: 470px;
            display: inline-block;
            border: 1px solid #ccc;
            height: 28px;
            text-align: right;
            vertical-align: middle;
            .el-upload-list__item {
              text-align: left;
              height: 30px;
              line-height: 30px;
              .el-icon-close {
                top: 8px;
              }
            }
          }
        }
        .bottoni {
          display: inline-block;
          width: 100px;
          vertical-align: middle;
          text-align: right;
          margin-left: 25px;
          .el-button {
              width: 150px;
            }
        }
      }
    }
  }

  @media only screen and (max-width: 875px) and (min-width: 776px) {
    .modal-documenti {
      .el-dialog__body {
        .upload {
          .upload-demo {
            width: 550px;
            .el-upload-list {
              width: 400px;
            }
          }
        }
      }
    }
  }

  @media only screen and (max-width: 775px) {
    .modal-documenti {
      .el-dialog__body {
        .upload {
          .upload-demo {
            width: 400px;
            .el-upload-list {
              width: 250px;
            }
          }
        }
      }
    }
  }

  .disegni-modal {
    .el-dialog__body {
      .prodotto {
        margin-bottom: 20px;
        .cod-prod {
          .set-font(@family: 'os-semibold', @size: 14px, @color: @textTable);
        }
        .des-prod {
          .set-font(@size: 14px, @color: @textTable);
        }
      }
    }
  }

  .modal-check {
    .el-dialog__body {
      .msg {
        .set-font(@size: 14px, @color: @textTable);
      }
    }
  }

  .last-offer-modal {
    .el-dialog {
      .el-dialog__header {
        border-bottom: 0;
      }
      .el-dialog__body {
        .el-tabs {
          .el-tabs__header {
            .el-tabs__item {
              width: 50%;
            }
          }
          .el-tabs__content {
            .col-sx {
              border-right: 1px solid @oroRiva;
              text-align: right;
              .lastoffer-label {
                .set-font(@size: 11px, @color: @greenRiva, @family: 'os-semibold');
                text-align: right;
                line-height: 25px;
                overflow: hidden;
                text-overflow: ellipsis;
                text-transform: uppercase;
                letter-spacing: 1px;
              }
            }
            .col-dx {
              .lastoffer-value {
                .set-font(@color: #454848, @size: 12px);
                word-wrap: break-word;
                white-space: normal;
                text-overflow: ellipsis;
                line-height: 25px;
                letter-spacing: 1px;
              }
            }
            .bottone-riporta {
              height: 30px;
              text-align: right;
              margin-top: 20px;
            }
          }
        }
      }
    }
  }

  .dettaglio-offerta {
    .header-tab {
      height: 70px;
      text-align: center;
      margin-bottom: 5px;
      .my-label {
        line-height: 55px;
        height: 45px;
        .set-font(@color: @oroRiva; @size: 22px; @family: 'os-semibolditalic');
        letter-spacing: 2px;
      }
      .sotto-label {
        .set-font(@size: 15px; @family: 'os-lightitalic');
        letter-spacing: 1px;
        height: 25px;
      }
      .icona-doc {
        .tooltip-div {
          width: 25px;
          float: right;
        }
        .fa-icon {
          color: @rossoRiva;
        }
      }
    }
    .testata {
      margin-top: 20px;
      .elemento-grande {
        margin-bottom: 0px !important;
      }
      .elemento {
        margin-bottom: 5px;
        .testata-label {
          .set-font(@size: 11px, @color: @greenRiva, @family: 'os-semibold');
          text-align: right;
          line-height: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        .testata-doppia {
          .my-label {
            margin-bottom: 5px;
            line-height: 16px;
          }
        }
        .testata-value {
          .pagamento {
            .set-font(@size: 12px, @color: @textTable);
            line-height: 14px;
            padding-top: 4px;
          }
          .modificato {
            .set-font(@size: 12px, @color: @oroRiva, @family: 'os-semibold');
            line-height: 14px;
            padding-top: 4px;
          }
          .custom-select-el {
            .is-disabled {
              .el-input__inner {
                background-color: #f5f7fa;
              }
              .el-input__inner:hover {
                border: 1px solid #dcdfe6 !important;
              }
            }
            .el-input__inner {
              height: 22px !important;
              border: 1px solid #dcdfe6;
              padding: 0 5px;
            }
          }
          .select-el-modificato {
            .el-input__inner {
              // border: 1px solid red !important;
              background-color: #ead8b4 !important;
              border: 1px solid #ead8b4 !important;
            }
          }
          .custom-input {
            .el-input__inner {
              height: 22px !important;
              padding: 0 5px;
              border: 1px solid #dcdfe6;
            }
          }
          .input-el-modificato {
            .el-input__inner {
              // border: 1px solid red !important;
              background-color: #ead8b4 !important;
              border: 1px solid #ead8b4 !important;
            }
          }
          .custom-date-picker {
            .el-input__inner {
              height: 22px !important;
              padding-left: 30px !important;
              border: 1px solid #dcdfe6;
            }
            .el-input__inner:focus {
              border-color: @greenRiva;
            }
            .el-input__prefix {
              left: 0;
            }
          }
        }
      }
    }
    .separatore {
      border-top: 1px solid #e7e7e7;
      margin-top: 15px;
      margin-bottom: 20px;
    }
    .dettaglio {
      min-height: 360px;
      .el-table {
        .el-table__body {
          .riaperto {
            background-color: #ead8b4;
          }
          .cell-no-padding-left {
            .cell {
              padding-left: 0 !important;
            }
          }
          .cell {
            .cerchio {
              height: 9px;
              width: 9px;
              border-radius: 5px;
            }
            .verde {
              background-color: #0B7E26;
            }
            .giallo {
              background-color: #FFD506;
            }
            .rosso {
              background-color: #E51717;
            }
          }
        }
      }
      .dettaglio-prodotto {
        .el-carousel {
          .el-carousel__container {
            height: 400px;
            .el-carousel__arrow--left {
              left: 0;
            }
            .el-carousel__arrow--right {
              right: 0;
            }
            .el-carousel__arrow {
              background-color: @white;
              .set-font(@size: 25px; @color: #ccc);
            }
            .el-carousel__arrow:focus {
              outline-width: 0px !important;
            }
            .card {
              margin-left: 28px;
              margin-right: 28px;
              height: 100%;
              overflow: auto;
              border: 0px !important;
              .titolo {
                text-align: center;
                .set-font(@size: 15px; @color: @greenRiva; @weight: bold);
              }
              .icone-prodotto-sx {
                text-align: right;
                color: @oroRiva;
                display: inline-block;
                div {
                  display: inline-block;
                }
                .action {
                  margin-left: 15px;
                  color: @rossoRiva;
                }
                .el-button {
                  border: none;
                  .set-font(@color: @rossoRiva, @family: 'os-regular', @size: 14px);
                  letter-spacing: 0;
                  text-decoration: underline;
                }
              }
              .icone-prodotto {
                 display: inline-block;
                 div {
                   display: inline-block;
                 }
                 .fa-icon {
                   margin-left: 15px;
                   color: @rossoRiva;
                 }
               }
              .des-estesa {
                text-align: center;
                .set-font(@size: 12px; @color: #606266);
                margin-left: auto;
                margin-right: auto;
                margin-top: 5px;
                width: 90%;
                div {
                  text-align: right;
                  .leggi-tutto {
                    .set-font(@size: 10px; @color: @greenRiva);
                  }
                }
              }
              .form {
                margin-top: 10px;
                .row-custom {
                  margin-bottom: 5px;
                  .prodotto-label {
                    text-align: right;
                    line-height: 20px;
                    .set-font(@color: @greenRiva, @size: 12px);
                  }
                  .u-mis {
                    .el-select {
                      .el-input__inner {
                        padding-right: 25px !important;
                      }
                    }
                  }
                  .custom-select-el {
                    .is-disabled {
                      .el-input__inner {
                        background-color: #f5f7fa;
                      }
                      .el-input__inner:hover {
                        border: 1px solid #dcdfe6 !important;
                      }
                    }
                    .el-input__inner {
                      height: 22px !important;
                      border: 1px solid #dcdfe6;
                      padding: 0 5px;
                    }
                  }
                  .custom-input-standard {
                    height: 22px !important;
                  }
                  .input-el-modificato {
                    // border: 1px solid red !important;
                    background-color: #ead8b4 !important;
                    border: 1px solid #ead8b4 !important;
                  }
                  .select-el-modificato {
                    .el-input__inner {
                      // border: 1px solid red !important;
                      background-color: #ead8b4 !important;
                      border: 1px solid #ead8b4 !important;
                    }
                  }
                  .divisa {
                    left: -10px;
                  }
                  .sett-cons {
                    text-align: left;
                    line-height: 20px;
                    .set-font(@color: @greenRiva, @size: 11px);
                  }
                }
              }
              .nota-fornitore-label {
                margin-top: 15px;
                text-align: center;
                .set-font(@size: 11px, @color: @greenRiva, @weight: bold);
              }
              .nota-fornitore-value {
                text-align: center;
                .set-font(@size: 11px, @color: #606266);
              }
            }
          }
        }
      }
    }
    .bottoni {
      margin-top: 10px;
      margin-bottom: 20px;
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Fornitura/RichiesteDiOfferta/DettaglioOfferta.vue